

//INTERVENTION STRINGS
// note: some of this is legacy stuff.
//    you'll notice that it's using our library function for string replacement rather than supplying a function.
//    Kept it this way for backward compatability
//    you'll also notice that we have nested arrays here rather than giving an individual key to each string. this works because these particular strings are selected at random from their buckets
// TODO: consider making a sub object for these strings
const EN_US_INTERVENTION_STRINGS = {
  pageGambitGoodPhrases: [
    "Excellent work.",
    "Lets keep reading.",
    "Here's the next page.",
    "You are reading well.",
    "Good reading.",
    "You are flying. Here's a new page.",
    "Outstanding.",
    "Turning the page.",
    "Here is a new page.",
    "Let's go on."
  ],
  pageGambitStrugglingPhrases: [
    "Terrific, you finished the page.",
    "Before the next page, just wanted to say great job.",
    "You are really working at this, thank you.",
    "You are reading well. Here's the next page.",
    "Keep trying.",
    "You are doing well. Here's a new page.",
    "Next page -- you are almost done.",
    "Good work. Next page."
  ],
  lastPhraseOnPageResponse: [
    "Nice!",
    "Super!",
    "Way to go!"
  ],
  readWithMePrompt: [
    "Your turn!",
    "Now you try!",
    "Ready? Read!",
    "Now try reading",
  ],
  try_again: [
    "let's try that again.",
    "read that to me again.",
    "try that one more time.",
    "how about you read that again?",
    "can you re-read that?",
    "ready to try again? Go!"
  ],
  keep_reading: {
    proficient: [
      "Keep going!",
      "Please go on.",
      "Keep reading.",
      "Lets go on.",
      "Read on.",
    ],
    capable: [
      "Let's keep reading!",
      "Keep going!",
      "Please go on.",
      "You're doing great.",
      "Keep reading."
    ],
    beginner: [
      "Let's keep reading!",
      "You're doing great.",
      "Let's read some more.",
      "Go on reading.",
    ],
  },
  read_perfectly: [
    "Great job, you read that perfectly!",
    "Fantastic job.",
    "Cool, that was good reading.",
    "Perfect Reading.",
    "No Errors.",
    "You didn't make a single mistake.",
    "Way to go, Zero errors.",
  ],
  storyPhrases: {
    proficient: [
      "Cool, you're done with this story.",
      "I have some feedback for you.",
      "Way to go. You've finished this story.",
      "Cool, you've finished this story.",
      "I have some feedback for you.",
      "Congratulations!",
      "Let's see how you did on this story.",
      "You've finished."
    ],
    capable: [
      "Way to go. You've finished this story.",
      "Cool, you've finished this story.",
      "I have some feedback for you.",
      "Finished. You did a great job.",
      "Congratulations. You red the entire story.", //Do not change this. Polly will mispronounce "read"
      "Congratulations.",
      "Lets see how you did on this story.",
      "You've finished."
    ],
    beginner: [
      "You got to the end. Wonderful job.",
      "The end. Way to go.",
      "Thanks for reading with me.",
      "lets see how you did with this story.",
      "That was fun and you red really well.", //Do not change this. Polly will mispronounce "read"
      "Finished. You did a great job.",
      "You did a great job.",
      "That was fun and you red really well.", //Do not change this. Polly will mispronounce "read"
    ],
  },
  toofastPhrases: {
    proficient: [
      "Can you slow down a bit so i can hear you better?",
      "Read at a comfortable speed, and i will follow you better.",
      "Help me out by reading clearly and not quite so quickly."
    ],
    capable: [
      "Can you slow down a bit so i can hear you better?",
      "Try saying each word clearly so I can understand you better.",
      "Help me out by reading a little more slowly.",
    ],
    beginner: [
      "I'm having a little trouble hearing you.  Say each word clearly.",
      "Help me follow you better by reading each word as clearly as you can.",
      "Raise your voice a little so I can hear you.",
      "Can you reed a little louder?",
    ],
  },
  comprehensionIntro: {
    proficient: [
      "Let's talk about the story.",
      "Can you tell me about the story?",
      "Great job. Here is a question for you about the story.",
      "Let's pause and think about what we've read.",
      "Let's think about what we've read."
    ],
    capable: [
      "Can you tell me about the story?",
      "Great job. Here is a question for you.",
      "Can you answer this question?",
      "Let's pause and think about what we've read.",
      "Let's think about what we've read."
    ],
    beginner: [
      "Here is a question for you about this story.",
      "Tell me about the story.",
      "Can you help me understand the story better?",
      "Let's pause and think about what we've read.",
    ],
  },
  comprehensionRightAnswer: {
    proficient: [
      "Great reading, that's right.",
      "You've got it!",
      "I'm so proud of you. You're doing great!"
    ],
    capable: [
      "Thanks. You are correct.",
      "Great reading, that's right.",
      "I'm so proud of you. You're doing great!"
    ],
    beginner: [
      "Great reading, that's right.",
      "Thanks. You are correct.",
      "I'm so proud of you. You're doing great!"
    ],
  },
  comprehensionWrongAnswerOnFirst: [
    "This answer needs to be fixed.",
    "Oops, let's check that answer.",
    "That question is tricky, can you check it again?",
    "I see this question stumped you, can you check it?"
  ],
  comprehensionWrongAnswerOnSecond: [
    "This answer needs to be fixed.",
    "Oops, let's check that answer.",
    "That question is tricky, can you check it again?",
    "I see this question stumped you, can you check it?"
  ],
  comprehensionWrongAnswerRetry: [
    "Oops, that's still not correct.",
    "Try again. That's not right.",
    "Let's check that answer again.",
    "Uh Oh.. that's not right."
  ],
  comprehensionWrongAnswer: [
    "Oops, that's not correct. Try again.",
    "Try again. That's not right.",
    "Uh Oh.. that's not right."
  ],
  comprehensionRight: {
    proficient: [
      "You are right.",
      "You got it!",
      "Yes, that's right.",
    ],
    capable: [
      "You got this one right.",
      "Cool. You are correct.",
      "That's right.",
      "You nailed it."
    ],
    beginner: [
      "You are right.",
      "You got it!",
      "Yes, that's right.",
    ],
  },
  comprehensionPrompt: [
    "This question might be tricky. Make your best guess by clicking on one of the answers.",
    "Which answer makes the most sense? Click on one of the answers."
  ],
  interventionOneErrorLeadInDontSayWord: {
    proficient: [
      "Let's review one word together.",
      "We should pause on a word",
      "Hold on. Lets work on a word.",
      "Let's drill in.",
      "Before we go on, lets work on one of the words.",
      "Looks like we should work on one of these words.",
      "We should spend a minute to review.",
    ],
    capable: [
      "Let's review a word together.",
      "Let's drill into one of the words.",
      "Looks like we should work on one of these words.",
      "We should work together for a minute.",
      "Hold on.  Lets work on a word.",
      "Here's some help.",
      "We should work on one of the words.",
    ],
    beginner: [
      "How about help with one of these words?",
      "Looks like we should focus on a word.",
      "Here's some help.",
      "Why don't we work on one of the words?",
      "Lets work on a word together.",
      "I'd like to tell you more about a word.",
    ],
  },
  interventionOneErrorLeadInSayWord: {
    proficient: [
      "Lets go over ${p0}.",
      "Let's review ${p0} together.",
      "Hold on. Lets review ${p0}.",
      "We should work on ${p0}.",
      "I'd like to drill in on ${p0}.",
      "Let's pause on ${p0}.",
      "We should work on ${p0}.",
      "We can go over ${p0}.",
      "Lets work on ${p0}.",
      "Lets talk about the word ${p0}",
      "Hold on, lets work on ${p0}.",
      "Before we go on,lets go over ${p0}.",
      "Looks like we should work on ${p0}.",
      "How about we work on ${p0}.",
      "We should spend a minute on ${p0}."
    ],
    capable: [
      "Let's review ${p0} together.",
      "Hold on. Lets review ${p0}.",
      "Let's drill in.",
      "We should focus on ${p0}.",
      "We should spend a second on ${p0}.",
      "Lets work on ${p0}.",
      "Lets talk about the word ${p0}",
      "let's hold on.",
      "Before we go on, let’s work on ${p0}.",
      "Looks like we should work on ${p0}.",
      "We should work on ${p0}.",
      "Lets go over ${p0}.",
      "We're going to work on ${p0}.",
      "Hold on, lets talk about ${p0}.",
      "How about we work on ${p0}.",
      "We should spend a minute on ${p0}."
    ],
    beginner: [
      "Hold on. lets work on ${p0}.",
      "Here's some help on the word ${p0}.",
      "We should work on the word ${p0}.",
      "Lets go over ${p0}.",
      "We should talk about the word ${p0}.",
      "Before we go on, let’s work on ${p0}.",
      "We should work on ${p0}.",
      "Lets go to work on ${p0}.",
      "We're going to work on ${p0}.",
      "Hold on, lets talk about ${p0}.",
      "We should spend a minute on ${p0}."
    ],
  },
  interventionMultipleErrorLeadIn: {
    proficient: [
      "Review can sharpen understanding.",
      "How about a quick review.",
      "We should review the sentence.",
      "Let's work on this sentence.",
      "We should go over that sentence again.",
      "Here's a quick recap.",
      "Why don't we work together for a minute?"
    ],
    capable: [
      "Let's try that sentence again.",
      "There was some trouble with that sentence.",
      "Let's do a quick review.",
      "I didn't catch some words.",
      "Looks like we should review.",
    ],
    beginner: [
      "We should go over that sentence again.",
      "Hmmm, we should review.",
      "Hold on. Let's work on this sentence.",
      "We should spend time going over that again.",
      "Wait, lets spend a second on these words.",
      "Lets work on this.",
      "How about we work on this?",
      "We should read that sentence again.",
      "Let's work together on this."
    ],
  },
  endOfClapPhrases: {
    beginner: [
      "Good work, keep reading.",
      "Nice work. Go on.",
      "Good going.",
      "Now you know another word. Keep reading.",
    ],
    capable: [
      "Great job, keep reading.",
      "Terrific. Go on.",
      "Nice work. Go on.",
      "You are a rock star. Keep reading.",
    ],
    proficient: [
      "Keep reading.",
      "Excellent. Go on.",
      "Terrific work. Go on.",
      "You are a rock star. Lets go on.",
    ],
  },
  feedbackUtterances: [
    "If I'm saying this, there's a bug",
    "Great job, let's do it again",
    "Good going.",
    "Great, now you know another word. Let's keep going."
  ],
  listening: {
    greatJob: [
      "Great job.",
      "Good work, thanks.",
      "Way to go.",
      "Super, lets keep going.",
      "Nice work.",
      "Got it.  Lets go on.",
    ],
    didntHear: [
      "Can you try again?",
      "I didn't hear you.",
      "Try again, please.",
      "Say it a little louder.",
      "Ok, I didn't get that. Try again.",
      "Can you say again, a little louder?",
      "Say it out loud, ok?",
      "What's the word?",
    ],
    moveOn: [
      "Ok, lets go on.",
      "Lets move on.",
      "Alright, keep reading.",
      "We'll keep going.",
      "Keep reading.",
      "Keep on going.",
      "We'll move on.",
      "Lets get back to reading.",
      "Ok, back to the story.",
    ],
    giveAnswer: [ //Listen.js appends the target word before sending the text to speech
      "The word is ",
      "Ok, its ",
      "This is ",
      "This word is ",
      "You say ",
    ],
    thanks: [
      "Ok, thanks.",
      "Appreciate you.",
      "thanks very much.",
      "Good effort.",
      "thank you, keep reading.",
    ]
  },
  rhymes_with: "This word rhymes with",
  this_word: "This word",
  rhymes: "rhymes",
  with: "with",
  listen_to_rhyme: "Listen to the rhyming word",
  listen_for_the: "Listen for the",
  spelling: "spelling",
  of: "of",
  is_spelled: "is spelled",
  let_me_spell: "Let me spell that for you",
  you_said: "You might have said",
  instead_of: "instead of",
  the_word_is: "<break time = \"0.5s\"/> The word is",
  important_word: " is an important word. Say ",
  three_times: " three times as fast as you can ",
  let_me_say: "Let me say that for you",
  means: "means",
  lets_read_the_word: "Let's read the word",
  fun_fact: "Fun Fact!",
  heres_a_fact: "Here's a fun fact for you about the word",
  watch_lips: "Watch my friend's lips say",
  tap_play: "when you are ready, tap the play button.",
  watch_how_to_say: "Watch how to say",
  now_you_say_word: "Now you say the word ",
  lets_read_word: "Let's read the word",
  let_me: "Let me",
  makes: "makes",
  say: "say",
  times: "times",
  now_you_try_word: "Now you try reading this word",
  im_going_to: "I'm going to",
  the_word_is_capitalized: "The word is",
  sound_out_capitalized: "Sound out",
  spellOutLeadIn: "Try to sound out this word.",
  spellOutLeadInBeforeVersion: "I'm going to spell out this word for you",
  imGoingToSoundThisWordOut: "I'm going to sound this word out",
  repeat_after_me: "Repeat after me",
  show_again: "I'll show you again",
  be_careful_not_to: "Be careful not to",
  make_this_mistake: " make this mistake",
  your_turn: "Your turn",
  wait: "Wait",
  mistake_added: (word) => ` add ${(/^[aeiou]$/i).test(word[0]) ? 'an' : ''} ${word} at the end.`,
  letsWorkOn: "Let's work on:",
  mistake_dropped: (word) => ` drop the ${word} ending.`,
  mistake_mix_up_ending: (word) => ` mix up the ${word} ending.`,
  is_pronounced: "is pronounced",
  word_has_many_letters_and_many_syllables: (wordLength, n) => `The word has ${wordLength} letters and ${n} ${n > 1 ? 'syllables' : 'syllable'}.`,
  word_has_many_letters_and_many_sounds: (wordLength, n) => `The word has ${wordLength} letters and ${n} ${n > 1 ? 'sounds' : 'sound'}.`,
  try_to_sound_it_out: "Try to sound it out",
  ok: "Ok,",
  ok_im_going_to_sound_out_this_word_for_you: "Ok, I'm going to sound out this word for you.",
  pay_attention_to_the_word_ending: "Pay attention to the word ending",
  letters: "Letters",
  sounds: "Sounds",


  /* intervention library strings */
  heres_a_riddle: "I’ve got a riddle for you.",
  riddle_solved: "Yes! You solved the riddle!",
  riddle_unsolved: (answer) => `I was hoping you'd say ${answer}.`,
  fun_fact: "Fun Fact!",
  heres_a_fact: "Here's a fun fact for you about the word",
  morpheme: {
    prefix: "beginning",
    suffix: "ending",
    root: "root",
    means: "means",
    intro: ({ morphemePosition }) =>
      `This word has a common ${morphemePosition}. If you know this ${morphemePosition}, you can figure out lots of words. <break time=\"1s\"/>`,
    examples: ({ morphemePosition }) =>
      `Here are some examples of words that use the ${morphemePosition}`,
    ask_word: ({ morphemePosition }) =>
      `Which of these words uses the same ${morphemePosition}?`,
    correct: 'is right. Whenever you see these letters together, they will tell you the word is about',
    struggle: ({ morphemePosition }) =>
      `is another word that uses the common ${morphemePosition}`,
  },
  elkonin_box: {
    intro_1: ({ nSounds }) =>
      `There are ${nSounds} sounds in this word. You can see ${nSounds} boxes on the screen. Move the first red ball into the first box, and say the first sound. Then move the other balls in the boxes, and say each sound.`,
    intro_2:
      "Watch as I move these balls into boxes. Each sound has its own box.",
    tutor_intro_part_1: "Here is a new sound game. I have a word with 3 sounds. The word is",
    tutor_intro_part_2: "I'm going to say the 3 sounds, and move one red ball into one box for each sound. Watch me do this first. The word is",
    ignore_extras:
      "There may be more boxes than sounds in the word. Just ignore the extras",
    ask_word: `Now put those sounds together and say the word.`,
    ask_sounds_1: ({ word }) => `Use your ${getInterface()} to move the balls into the boxes and say each sound in the word ${word}.`,
    ask_sounds_2: `Use your ${getInterface()} to move the balls into the boxes, and say the sounds of the word shown in the picture.`,
    your_turn: `Now it's your turn.`,
    your_turn_tutor: "Now you try it. The word is:",
    ask_blend: `Now, blend the sounds into the word.`,
    correct: `Great job on`,
    blend: `Now, I'll blend those sounds into`,
    describe_1:  `The word`,
    describe_2: ({ nSounds }) => `has ${nSounds} sounds.`,
    feedback_1:
      `Use your ${getInterface()} to move a ball and say each of the sounds in`,
    feedback_2_part_1: `The sounds in the word`,
    feedback_2_part_2: `are`,
    struggle_part_1: `The word is`,
    struggle_part_2: `Let's keep going.`,
    too_many_sounds: "Too many sounds.",
    the_sounds_are: "The sounds in the word are",
    what_word: "what word does that make?",
    drag_the_circles: "Drag the circles into the boxes",
    lets_work_on: ({ word }) => `Let's work on ${word}`,
  },
  cognate_intro: (word, cognate) =>
    `${word} is <lang xml:lang="es-ES">${cognate}</lang> in spanish.`,
  cognate_now_you_say_it: "Now You say the word in English.",
  name: {
    ask_sounds: `Let's sound out this name. Say the first sound and then keep going with each sound.`,
    intro_1_part_1: `This is a`,
    intro_1_part_2: `name that means`,
    intro_2: `is a famous`,
    ask_word_1: `Great, now run your ${getInterface()} over the parts from the beginning to end and say the name.`,
    ask_word_2: "Now, you pronounce this name.",
    correct_1: `Yes, this name is pronounced`,
    correct_2: "Good work, thanks.",
    struggle_part_1: `This name is pronounced`,
    struggle_part_2: `Let's keep reading.`,
    fun_fact: `Here's a fun fact:`,
    lip_sync: "Watch my friend break this name into parts.",
  },
  vocabulary_with_picture: {
    title: "Vocabulary With Pictures",
    intro: (descriptor) => `is a ${descriptor} word.`,
    question_text: 'Which picture best shows the word',
    correct_response: "You are right!",
    means: 'means',
    descriptor: ["pretty hard"],
  },
  sound_seeker: {
    intro: `We're going to find a sound in`,
    describe_1: ({ isStart }) => `${isStart ? "starts" : "ends"} with`,
    yes: 'Yes',
    describe_2: ({ isStart }) => `also ${isStart ? "starts" : "ends"} with`,
    ask_word: ({ isStart }) =>
      `${
        isTouchDevice() ? "tap" : "click"
      } on the picture that ${isStart ? "starts" : "ends"} with`,
    correct: `Thanks for sound seeking. Let's do some reading.`,
    no: 'no',
    incorrect: ({ isStart }) => `doesn't ${isStart ? "start" : "end"} with`,
    its_this_one: "It's this one.",
    like_word: 'just like',
  },
  prediction_question: {
    intro:
      'Ok, lets see how good you are at guessing what happens next.<break time="0.5s"/> Think about the story we’ve read so far.',
    correct_response: "Good prediction, I'm so proud of you.",
    expire_right_answer: (answer) => `The right answer is: ${answer}.`,
    struggle: `Ok, trying to figure out what's coming is an important part of reading. Let's see what happens. Keep reading.`,
  },
  sound_out: {
    intro: `I'm going to sound out this word for you.`,
    ask_sounds: `Ok, now it's your turn. Say each sound.`,
    ask_word: "What word does that make?",
  },
  letter_flies: {
    intro: `When you hear me say a sound, catch the butterfly that matches the sound. You do this by ${
      isTouchDevice() ? "tapping" : "clicking"
    } the butterfly with the letter that matches the sound.<break time="1s"/> Watch me do this first.`,
    your_turn: `Now it's your turn.`,
    catch_butterfly: `The sound to catch is`,
    click_on: isTouchDevice() ? "tap on" : "click on",
    ask_sound_part_1: `Ok, now say the sound`,
    ask_sound_part_2: `makes`,
    struggle: "Oh no. The letterfly is escaping.",
    correct_1: "You caught that letterfly.",
    correct_2: `That's the way to collect letter flies.`,
    tutor: {
      intro: "When you hear me say a sound, catch the letterfly that matches the sound. You do this by clicking the butterfly with the letter that matches the sound.<break time=\"1s\"/> Watch me do this first.",
      on_no_click_action_1: `click on the letter that makes the`,
      on_no_click_action_2: `sound.`,
      struggle: `Oh no. The letterfly is escaping, don't worry, we will catch more later.`,
      your_turn_instruction_1: `Now it's your turn.`,
      your_turn_instruction_2: `has the`, // [word] has the [sound]
      your_turn_instruction_3: `sound. Which letter makes the`,
      your_turn_instruction_4: `sound?`, // [sound] sound?
      silent_letter: ({targetGrapheme}) => `<speak><prosody rate="slow">${targetGrapheme}</prosody></speak>`,
      silent_instruction_1: `Can you say the sound`,
      silent_instruction_2: `makes?`, // [sound] makes?
      silent_instruction_3: `makes the`,
      silent_instruction_4: `<speak><break time="1s"/>sound.</speak>`, // [sound]?
    },
  },
  say_a_sound: {
    intro: ({ nSounds }) =>
      `Watch my friend's mouth for each of the ${nSounds} sounds in this word.`,
    ask_sounds: `Now I'm going to show you the letters for each of these sounds and you say the sound.`,
    ask_word: "Now, read the whole word.",
  },
  word_display: {
    intro: "Watch and listen. We're going to learn more about this word.",
    ask_sound_part_1: `What is the first sound in`,
    ask_sound_part_2: `?`,
    describe_part_1: `Ok`,
    describe_part_2: `starts with`,
    continue: `Let's get back to reading.`,
  },
  up_and_down: {
    intro_1_intervention: `Watch your friend go up the stairs as I say the sounds in the word`,
    intro_1_tutor: `I’m going to say the sounds in a word, then I’m going to blend them together to say the word. Watch me do this first`,
    intro_2: `Help your friend climb up the stairs by saying the sounds in the word`,
    ask_sounds_intervention: `Now you try it. Say all the sounds in`,
    ask_sounds_tutor: `Now it’s your turn. The word is`,
    prompt_sounds: 'Can you say the sounds in',
    ask_blend_intervention: "Blend the sounds in the word.",
    ask_blend_tutor: "What word does that make?",
    correct: `Great job.`,
    struggle_intro: `The word is`,
    struggle_end: `Let's read some more.`,
    repeat_after_me: `Repeat after me`,
  },
  rhyming: {
    intro: `Let's learn about this word with rhymes.`,
    describe: `Our word rhymes with`,
    ask_word_1: `So, read this word that rhymes with`,
    ask_word_2: `Now you read`,
    correct: "You mastered this rhyme.",
    struggle: `Let's use the rhyme.`,
    rhymes_with: "rhymes with",
  },
  rhyming_quiz: {
    intro: "Time for the rhyming game.",
    our_word_is: 'Our word is',
    which_rhymes_with: 'Which of these words rhymes with',
    click_to_choose: () => `${
      isTouchDevice() ? "Touch" : "Click"
    } to choose.`,
    you_are_right: 'You are right.',
    no: "No, ",
    doesnt_rhyme_with: "doesn't rhyme with",
    but: "But",
    does: "does",
    rhymes_with: 'rhymes with',
    back_to_reading: 'Back to reading.',
  },
  say_one_sound: {
    intro: "Watch and listen as I say this word",
    describe: ({ position }) =>
      `I'm going to say the ${position} sound in the word`,
    ask_word: `Now it's your turn. Say the word`,
    struggle: `We're going to work on`,
    ask_sound: ({ position }) =>
      `Now say the ${position} sound in`,
    sound_is: "Okay, the sound is",
    correct: "Way to go.",
    first: "first",
    last: "last",
  },
  word_investigator: {
    intro: ({ word }) =>
      `Look at this word. This word should have ${word.length} letters and ${word.length} sounds. But there is a letter and a sound missing. Let's investigate.`,
    describe_1: ({ word }) => `has ${word.length} sounds.`,
    describe_2: ({ word }) =>
      `but there are only ${word.length - 1} sounds here. The`,
    describe_3: `Find the letter that makes the missing sound in`,
    missing: "is missing.",
    ask_letter: `${
      isTouchDevice() ? "tap" : "click"
    } on the letter at the top that makes the missing sound.`,
    correct_1: "Right. You are a good investigator.",
    correct_2: "Great, thanks.",
    struggle: `That's not the right letter sound.`,
    try_again: `On inspection, let's keep trying.`,
    give_answer_part_1: `The missing letter is`,
    give_answer_part_2: `Now, you read the word.`,
    inactivity: `Give it a try. ${
      isTouchDevice() ? "tap" : "click"
    } on a letter at the top.`,
  },
  give_and_take: {
    time_to_get_goofy: 'Time to get goofy with the word',
    watch_and_listen: ({ isStart }) => `Watch and listen as I say the ${isStart ? 'first' : 'last'} part of this word.`,
    describe: ({ nSounds }) => `This word part has ${nSounds} sounds.`,
    ask_word_part: "Say the word part with me.",
    correct_1: "You did it",
    correct_2: `Let's keep going.`,
    correct_3: "Way to go.",
    ok_new_word_is: 'Ok, our new word is',
    thanks: 'Thanks',
    struggle_1: "The word part is ",
    struggle_2: "Now the word is in the boxes. Read the whole word to me.",
    this_word_is: 'This word is',
    back_to_reading: 'Back to reading.',
    add_sound: ({ isStart }) =>
      `Now, I am going to add the ${isStart ? 'first' : 'last'} part to our word. The new sound is`,
    word_is: "Now the word is",
    makes_word: "That makes the word",
    ask_sounds: ({ nSounds }) => `Now, repeat the ${nSounds} sounds.`,
    ask_word: `Now read the whole word.`,
    replace_sound: `Ok, one last step. Let's replace a sound. We're going to change the sound`,
    to: "to",
    ask_sub: "Now sound out the new word.",
  },
  change_one_part: {
    intro: "Time for the letter swap game. Watch and listen to this sound out.",
    change_one: `I'm going to change one letter in this word. Changing the letter will change the sound and make a new word.`,
    ask_word: "Can you read this word?",
    another_swap: `Let's do another swap.`,
    correct: "Good work.",
    sound_out: `Ok, let's sound out this word together.`,
    good_job: `Good letter swapping. Thanks`,
    assessment_handle_intro: `We are now going to play a game with words.  Wait to read until I let you know it’s time`,
    assessment_handle_intro_say_word: 'This word is <break time="0.5s"/>',
    assessment_handle_intro_make_change: `I’m going to change one letter in this word. Changing the letter will change the sound and make a new word.`,
    assessment_handle_intro_prompt_to_try_transition: `When you see the boxes turn yellow, you should then read the new word.`,
    assessment_handle_intro_prompt_to_try_read: 'Give it a try: read <break time="0.5s"/>',
    assessment_handle_intro_silence: 'You should read <break time="0.5s"/>',
    assessment_handle_silence: `You can do it! Please read the new word.`,
    assessment_handle_first_item_prompt: 'Ok, now let’s play with the word <break time="0.5s"/>',
    assessment_handle_first_item_make_change: `Let's change one letter`,
    assessment_handle_first_item_prompt_to_read: `Now it is your turn to read the new word.`,
    assessment_handle_nth_item_prompt: 'Ok, let’s play with the word <break time="0.5s"/>',
    assessment_handle_nth_item_make_change: `Let's change one letter`,
    assessment_handle_nth_item_prompt_to_read: `What's the word?`,
    assessment_handle_item_done_try_another: `Good try. Now let's try some other words.`,
    assessment_handle_end: `Got it!  Thanks.`,
    end: "Thank you!",
    tutor_example_intro_FTUE: "Let's play the letter swap game. Watch me play first by changing a sound and making a new word. The word is",
    tutor_example_change_one_FTUE: "Now I change the sound and look, the new word is",
    tutor_example_change_one: `Let's change one sound.`,
    tutor_example_intro: "Next, let's play with the word",
    tutor_example_ask_word: `Now you try. Read the new word.`,
    tutor_subsequent_ask_word: `Please read the new word.`,
    tutor_silent_ask_word: `Can you say the sounds in the new word?`,
    tutor_silent_end: `The word is`,
    non_ortho: {
      example: {
        we_are_now: `We are now going to play a game with words. Wait to speak until I let you know it's time.`,
        these_boxes_represent: `These three boxes represent the three sounds in the word`,
        those_sounds_are: `Those three sounds are`,
        im_going_to_change: `I'm going to change one sound in the word`,
        im_going_to_change_2: `I'm going to change the`,
        sound_to_the: `sound to the`,
        sound_which_will_make: `sound, which will make a new word.`,
        when_you_see_the_boxes: `When you see the boxes turn yellow, you should say the new word that it makes if I change the`,
        in: `in`,
        to_a: `to a`,
      },
      subsequent: {
        now_lets_play_with: `Now let's play with the word`,
        these_boxes_represent: `These three boxes represent the three sounds in the word`,
        those_sounds_are: `Those three sounds are`,
        lets_change: `Now let's change the`,
        sound_to_the: `sound to the`,
        sound: `sound`,
      }
    }
  },
  word_scramble: {
    before_we_look_at: 'Before we look at',
    lets_talk_about: "let's talk about",
    sound_out: `Let's sound out this word together.`,
    scrambled: "Uh-oh, the word got scrambled. Watch me fix this word.",
    fix_scrambled: `To fix scrambled words, just use your ${getInterface()} to drag the letters to the right place.`,
    ask_unscramble: "Move the boxes to fix the word.",
    your_turn: "Your turn",
    ask_word_1: "Read this word.",
    ask_word_2: "Now, read this word.",
    this_is_our_word: 'This is our word',
    unscrambled: 'unscrambled',
    lets_do_some_reading: "Let's do some reading.",
    you_got: 'You got',
    back_in_order: 'back in order',
    fantastic_job: 'Fantastic job',
  },  /* end intervention library strings */


  comprehensionPrompt: [
    "This question might be tricky. Make your best guess by clicking on one of the answers.",
    "Which answer makes the most sense? Click on one of the answers.",
  ],
  comprehensionWrongAnswer: [
    "Oops, that's not correct. Try again.",
    "Try again. That's not right.",
    "Uh Oh.. that's not right.",
  ],
};












const ES_MX_INTERVENTION_STRINGS = {
  pageGambitGoodPhrases: [
    "Excelente trabajo.",
    "Sigamos leyendo.",
    "Aquí está la siguiente página",
    "Estás leyendo bien.",
    "Buena lectura.",
    "¡Vas muy bien! Aquí tienes una página nueva.",
    "Espectacular.",
    "Pasemos de página.",
    "Aquí tienes una página nueva.",
    "Continuemos."
  ],
  pageGambitStrugglingPhrases: [
    "Estupendo, terminaste la página.",
    "Antes de pasar a la siguiente página, quiero felicitarte. ¡Buen trabajo!",
    "Gracias por todo tu esfuerzo.",
    "Estás leyendo bien. Aquí está la siguiente página.",
    "Sigue intentándolo.",
    "¡Vas muy bien! Aquí tienes una página nueva.",
    "Siguiente página. Ya casi terminas.",
    "Buen trabajo. Siguiente página."
  ],
  lastPhraseOnPageResponse: [
    "¡Genial!",
    "¡Súper!",
    "¡Bien hecho!"
  ],
  readWithMePrompt: [
    "¡Ahora es tu turno!",
    "¡Ahora inténtalo tú!",
    "¡A leer!",
    "Ahora intenta leer."
  ],
  try_again: [
    "Vamos a intentarlo otra vez.",
    "Vuelve a leer eso.",
    "Inténtalo una vez más.",
    "¿Qué tal si lo vuelves a leer?",
    "¿Puedes volver a leer eso?",
    "¿Lo intentamos otra vez? ¡Adelante!"
  ],
  keep_reading: {
    proficient: [
      "¡Sigue adelante!",
      "Puedes continuar.", //removing accent on continúa here and elsewhere because amira sounds weird when she says it
      "Sigue leyendo.",
      "Continuemos.",
      "Puedes seguir leyendo."
    ],
    capable: [
      "¡Sigamos leyendo!",
      "¡Sigue adelante!",
      "Puedes continuar.",
      "¡Vas muy bien!",
      "Sigue leyendo."
    ],
    beginner: [
      "¡Sigamos leyendo!",
      "¡Vas muy bien!",
      "Leamos un poco más.",
      "Sigue leyendo.",
    ],
  },
  read_perfectly: [
    "Excelente trabajo, ¡leíste eso perfectamente!",
    "Buen trabajo",
    "Genial, leíste muy bien.",
    "¡Leíste perfecto!",
    "No cometiste ningún error.",
    "No cometiste ni un solo error.",
    "¡Bien hecho! No cometiste ningún error."
  ],
  storyPhrases: {
    proficient: [
      "Genial, ya terminaste esta historia.",
      "Te haré algunas observaciones.",
      "¡Bien hecho! Ya terminaste esta historia.",
      "Genial, ya terminaste esta historia.",
      "Te haré algunas observaciones.",
      "¡Felicitaciones!",
      "Veamos cómo te fue con esta historia.",
      "Terminaste."
    ],

    capable: [
      "Bien hecho. Ya terminaste esta historia.",
      "Genial, ya terminaste esta historia.",
      "Te haré algunas observaciones.",
      "Ya terminaste. ¡Bien hecho!",
      "Felicitaciones, leíste toda la historia.",
      "Felicitaciones.",
      "Veamos cómo te fue con esta historia.",
      "Terminaste."
    ],
    beginner: [
      "Llegaste al final. Buen trabajo.",
      "Terminaste. Bien hecho.",
      "Gracias por leer conmigo.",
      "Veamos cómo te fue con esta historia.",
      "Eso fue divertido y leíste muy bien.",
      "Terminaste. ¡Bien hecho!",
      "Hiciste un buen trabajo.",
      "Eso fue divertido y leíste muy bien."
    ],
  },
  toofastPhrases: {
    proficient: [
      "¿Puedes leer más despacio? Así te oiré mejor.",
      "Lee a un ritmo cómodo. Así te entenderé mejor.",
      "Necesito tu ayuda: lee con claridad y un poco más despacio."
    ],
    capable: [
      "¿Puedes leer más despacio? Así te oiré mejor.",
      "Intenta pronunciar claramente cada palabra. Así te entenderé mejor.",
      "Necesito tu ayuda: lee un poco más despacio."
    ],
    beginner: [
      "No te oigo bien. Pronuncia claramente cada palabra.",
      "Ayúdame a entenderte mejor. Lee cada palabra lo más claro que puedas.",
      "Sube un poco la voz para que pueda oírte.",
      "¿Puedes leer un poco más alto?"
    ],
  },
  comprehensionIntro: {
    proficient: [
      "Hablemos sobre la historia.",
      "¿Puedes hablarme de la historia?",
      "Buen trabajo. Aquí tienes una pregunta sobre la historia.",
      "Hagamos una pausa y pensemos en lo que hemos leído.",
      "Pensemos en lo que hemos leído."
    ],
    capable: [
      "¿Puedes hablarme de la historia?",
      "Buen trabajo. Tengo una pregunta para ti.",
      "¿Puedes contestar esta pregunta?",
      "Hagamos una pausa y pensemos en lo que hemos leído.",
      "Pensemos en lo que hemos leído."
    ],
    beginner: [
      "Aquí tienes una pregunta sobre la historia.",
      "Háblame de la historia.",
      "¿Puedes ayudarme a entender mejor la historia?",
      "Hagamos una pausa y pensemos en lo que hemos leído."
    ],
  },
  comprehensionRightAnswer: {
    proficient: [
      "Leíste muy bien. ¡Esa es la respuesta correcta!",
      "¡Eso es!",
      "Estoy muy orgullosa de ti. ¡Lo estás haciendo genial!"
    ],
    capable: [
      "Gracias. Respondiste correctamente.",
      "Leíste muy bien. ¡Esa es la respuesta correcta!",
      "Estoy muy orgullosa de ti. ¡Lo estás haciendo genial!"
    ],
    beginner: [
      "Leíste muy bien. ¡Esa es la respuesta correcta!",
      "Gracias. Respondiste correctamente.",
      "Estoy muy orgullosa de ti. ¡Lo estás haciendo genial!"
    ],
  },
  comprehensionWrongAnswerOnFirst: [
    "Hay que corregir esta respuesta.",
    "¡Vaya! Revisemos esa respuesta.",
    "Esa pregunta es complicada. ¿Puedes revisarla?",
    "Veo que esta pregunta te resultó difícil. ¿Puedes revisarla?"
  ],
  comprehensionWrongAnswerOnSecond: [
    "Hay que corregir esta respuesta",
    "¡Vaya! Revisemos esa respuesta.",
    "Esa pregunta es complicada. ¿Puedes revisarla?",
    "Veo que esta pregunta te resultó difícil. ¿Puedes revisarla?"
  ],
  comprehensionWrongAnswerRetry: [
    "¡Vaya! ¡Esa tampoco es la respuesta correcta!",
    "Inténtalo otra vez. Esa respuesta es incorrecta.",
    "Revisemos esa respuesta una vez más.",
    "Oh, oh… esa no es la respuesta correcta."
  ],
  comprehensionWrongAnswer: [
    "¡Vaya! Esa no es la respuesta correcta. Inténtalo otra vez.",
    "Inténtalo otra vez. Esa respuesta es incorrecta.",
    "Oh, oh… esa no es la respuesta correcta."
  ],
  comprehensionRight: {
    proficient: [
      "Respondiste correctamente.",
      "¡Eso es!",
      "Sí, esa es la respuesta correcta."
    ],
    capable: [
      "Respondiste correctamente.",
      "Genial. Respondiste correctamente.",
      "Esa es la respuesta correcta.",
      "Acertaste."
    ],
    beginner: [
      "Respondiste correctamente.",
      "¡Eso es!",
      "Sí, esa es la respuesta correcta."
    ],
  },
  comprehensionPrompt: [
    "Esta pregunta puede ser complicada, pero inténtalo. Haz clic en una de las respuestas.",
    "¿Cuál de las respuestas tiene más sentido? Haz clic en una de ellas."
  ],
  interventionOneErrorLeadInDontSayWord: {
    proficient: [
      "Vamos a revisar una palabra.",
      "Vamos a detenernos en una palabra.",
      "Espera. Practiquemos una palabra.",
      "Vamos a repasar",
      "Antes de continuar, practiquemos una de las palabras.",
      "Parece que debemos practicar una de estas palabras.",
      "Saquemos un minuto para repasar."
    ],
    capable: [
      "Vamos a revisar una palabra.",
      "Vamos a repasar una de las palabras.",
      "Parece que debemos practicar una de estas palabras.",
      "Saquemos un minuto para repasar.",
      "Espera. Practiquemos una palabra.",
      "Esto puede servirte de ayuda.",
      "Deberíamos practicar una de las palabras."
    ],
    beginner: [
      "¿Qué tal si te ayudo con una de estas palabras?",
      "Parece que debemos enfocarnos en una palabra.",
      "Esto puede servirte de ayuda.",
      "¿Por qué no practicamos una de las palabras.",
      "Practiquemos una palabra.",
      "Quiero hablarte acerca de una palabra."
    ],
  },
  interventionOneErrorLeadInSayWord: {
    proficient: [
      "Vamos a repasar la palabra ${p0}.",
      "Revisemos la palabra ${p0}.",
      "Espera. Revisemos la palabra ${p0}.",
      "Deberíamos practicar la palabra ${p0}.",
      "Me gustaría repasar la palabra ${p0}.",
      "Vamos a detenernos en la palabra ${p0}.",
      "Deberíamos practicar la palabra ${p0}.",
      "Podemos repasar la palabra ${p0}.",
      "Practiquemos la palabra ${p0}.",
      "Hablemos sobre la palabra ${p0}.",
      "Espera. Practiquemos la palabra ${p0}.",
      "Antes de continuar, repasemos la palabra ${p0}.",
      "Parece que debemos practicar la palabra ${p0}.",
      "¿Qué tal si practicamos la palabra ${p0}?",
      "Saquemos un minuto para repasar la palabra ${p0}."
    ],
    capable: [
      "Revisemos la palabra ${p0}.",
      "Espera. Revisemos la palabra ${p0}.",
      "Vamos a repasar.",
      "Deberíamos enfocarnos en la palabra ${p0}.",
      "Saquemos un momento para repasar la palabra ${p0}.",
      "Practiquemos la palabra ${p0}.",
      "Hablemos sobre la palabra ${p0}.",
      "Hagamos una pausa.",
      "Antes de continuar, practiquemos la palabra ${p0}.",
      "Parece que debemos practicar la palabra ${p0}.",
      "Deberíamos practicar la palabra ${p0}.",
      "Revisemos la palabra ${p0}.",
      "Vamos a practicar la palabra ${p0}.",
      "Espera. Hablemos sobre la palabra ${p0}.",
      "¿Qué tal si practicamos la palabra ${p0}?",
      "Saquemos un minuto para repasar la palabra ${p0}."
    ],
    beginner: [
      "Espera. Practiquemos la palabra ${p0}.",
      "Esto puede ayudarte con la palabra ${p0}.",
      "Deberíamos practicar la palabra ${p0}.",
      "Revisemos la palabra ${p0}.",
      "Deberíamos hablar sobre la palabra ${p0}.",
      "Antes de continuar, practiquemos la palabra ${p0}.",
      "Deberíamos practicar la palabra ${p0}.",
      "Practiquemos la palabra ${p0}.",
      "Vamos a practicar la palabra ${p0}.",
      "Espera. Hablemos sobre la palabra ${p0}.",
      "Saquemos un minuto para repasar la palabra ${p0}."
    ],
  },
  interventionMultipleErrorLeadIn: {
    proficient: [
      "Repasar puede ayudarte a comprender mejor.",
      "¿Qué tal si hacemos un repaso rápido?",
      "Deberíamos revisar la oración.",
      "Practiquemos esta oración.",
      "Deberíamos repasar esa oración.",
      "Hagamos un repaso rápido.",
      "¿Por qué no trabajamos en equipo por un minuto."
    ],
    capable: [
      "Intentemos releer esa oración.",
      "Hubo un problema con esa oración.",
      "Hagamos un repaso rápido.",
      "No entendí algunas palabras.",
      "Parece que debemos repasar.",
    ],
    beginner: [
      "Deberíamos repasar esa oración.",
      "Mmm..., deberíamos repasar.",
      "Espera. Practiquemos esta oración.",
      "Saquemos un momento para repasar eso.",
      "Espera. Saquemos un minuto para repasar estas palabras.",
      "Practiquemos esto.",
      "¿Qué tal si practicamos esto?",
      "Deberíamos releer esa oración.",
      "Vamos a practicar esto."
    ],
  },
  endOfClapPhrases: {
    beginner: [
      "Buen trabajo. Sigue leyendo.",
      "Bien hecho. Puedes continuar.",
      "Vas muy bien.",
      "Aprendiste una nueva palabra. Sigue leyendo."
    ],
    capable: [
      "¡Excelente! Sigue leyendo.",
      "Magnífico. Puedes continuar.",
      "Bien hecho. Puedes continuar.",
      "Eres toda una estrella. Sigue leyendo."
    ],
    proficient: [
      "Sigue leyendo.",
      "Excelente. Puedes continuar.",
      "Magnífico trabajo. Puedes continuar.",
      "Eres toda una estrella. Continuemos."
    ],
  },
  feedbackUtterances: [
    "Si digo esto, hay un error en el programa.",
    "Buen trabajo, hagámoslo de nuevo.",
    "Vas muy bien.",
    "Genial, aprendiste una palabra nueva. Continuemos."
  ],
  listening: {
    greatJob: [
      "¡Excelente!",
      "Buen trabajo. Gracias.",
      "Bien hecho.",
      "¡Fantástico! Continuemos.",
      "Buen trabajo.",
      "Muy bien.  Continuemos."
    ],
    didntHear: [
      "¿Puedes volver a intentarlo?",
      "No te escuché.",
      "Inténtalo otra vez, por favor.",
      "Dilo un poco más alto.",
      "No te entendí. Inténtalo otra vez.",
      "¿Puedes repetirlo un poco más alto?",
      "Dilo más alto, ¿de acuerdo?",
      "¿Cuál es la palabra?"
    ],
    moveOn: [
      "De acuerdo, continuemos.",
      "Sigamos adelante..",
      "Muy bien, sigue leyendo.",
      "Vamos a continuar.",
      "Sigue leyendo.",
      "Puedes continuar.",
      "Vamos a seguir adelante.",
      "Sigamos leyendo.",
      "De acuerdo, volvamos a la historia."
    ],
    giveAnswer: [ //Listen.js appends the target word before sending the text to speech
      "La palabra es ",
      "De acuerdo, es ",
      "Este es ",
      "Esta palabra es ",
      "Tú dices ",
    ],
    thanks: [
      "De acuerdo, gracias.",
      "Te lo agradezco.",
      "Muchas gracias.",
      "Tu esfuerzo ha valido la pena.",
      "Gracias, sigue leyendo."
    ]
  },
  rhymes_with: "Esta palabra rima con",
  this_word: "Esta palabra",
  rhymes: "rima",
  with: "con",
  listen_to_rhyme: "Escucha la palabra que rima",
  listen_for_the: "Escucha el",
  spelling: "deletreo",
  of: "de",
  is_spelled: "se deletrea",
  let_me_spell: "Permíteme deletrear la palabra",
  you_said: "Pudiste haber dicho",
  instead_of: "en lugar de",
  the_word_is: "La palabra es",
  important_word: "es una palabra importante. Di",
  three_times: " tres veces lo más rápido que puedas.",
  let_me_say: "Permíteme decir la palabra",
  means: "significa",
  lets_read_the_word: "Leamos la palabra",
  fun_fact: "¡Dato curioso!",
  heres_a_fact: "Aquí tienes un dato curioso acerca de esa palabra",
  watch_lips: "Observa los labios de esta persona diciendo",
  tap_play: "Para continuar, toca el botón de reproducción.",
  watch_how_to_say: "Observa cómo se dice",
  now_you_say_word: "Ahora di tú la palabra ",
  lets_read_word: "Leamos la palabra",
  let_me: "Permíteme",
  makes: "se pronuncia",
  say: "dilo",
  times: "veces",
  now_you_try_word: "Ahora trata de leer esta palabra",
  im_going_to: "Voy a",
  the_word_is_capitalized: "La palabra es",
  sound_out_capitalized: "Articulación de sonidos",
  spellOutLeadIn: "Intenta pronunciar los sonidos que forman esta palabra.",
  spellOutLeadInBeforeVersion: "Voy a deletrear esta palabra.",
  imGoingToSoundThisWordOut: "Voy a pronunciar los sonidos que forman esta palabra",
  repeat_after_me: "Repite conmigo.",
  show_again: "Te lo mostraré de nuevo",
  be_carful_not_to: "Procura no",
  make_this_mistake: "cometer este error",
  your_turn: "Es tu turno",
  wait: "Espera",
  mistake_added: (word) => ` añadir ${(/^[aeiou]$/i).test(word[0]) ? 'an' : ''} ${word} al final.`,
  letsWorkOn: "Vamos a trabajar en:",
  mistake_dropped: (word) => ` omitir la terminación de la palabra ${word}.`,
  mistake_mix_up_ending: (word) => ` cambiar la terminación de la palabra ${word}.`,
  is_pronounced: "se pronuncia",
  word_has_many_letters_and_many_syllables: (wordLength, n) => `La palabra tiene ${wordLength} letras y ${n} ${n > 1 ? 'sílabas' : 'syllable'}.`,
  word_has_many_letters_and_many_sounds: (wordLength, n) => `La palabra tiene ${wordLength} letras y ${n} ${n > 1 ? 'sonidos' : 'sonido'}.`,
  try_to_sound_it_out: "Intenta pronunciar los sonidos que forman esta palabra",
  ok: "De acuerdo,",
  ok_im_going_to_sound_out_this_word_for_you: "Voy a pronunciar los sonidos que forman esta palabra.",
  pay_attention_to_the_word_ending: "Presta atención a la terminación de esta palabra",
  letters: "Letras",
  sounds: "Sonidos",

  /* intervention library strings */
  heres_a_riddle: "Tengo un acertijo para ti.",
  riddle_solved: "¡Sí!¡Resolviste el acertijo!",
  riddle_unsolved: (answer) => `Esperaba que dijeras ${answer}.`,
  fun_fact: "¡Dato curioso!",
  heres_a_fact: "Aquí hay un dato curioso sobre la palabra",
  morpheme: {
    prefix: "principio",
    suffix: "final",
    root: "raíz",
    means: 'significa',
    intro: ({ morphemePosition }) =>
      `Esta palabra tiene un ${morphemePosition} común. Si conoces este ${morphemePosition}, puedes descifrar muchas palabras. <break time=\"1s\"/>`,
    ejemplos: ({ morphemePosition }) =>
      `Aquí hay varios ejemplos de palabras que usan el ${morphemePosition}`,
    ask_word: ({ morphemePosition }) =>
      `¿Cuál de estas palabras usa el mismo ${morphemePosition}?`,
    correct: 'está correcta. Cada vez que ves estas letras juntas, significa que la palabra trata sobre',
    struggle: ({ morphemePosition }) =>
      `es otra palabra que usa el ${morphemePosition} común`,
  },
  elkonin_box: {
    intro_1: ({ nSounds }) =>
      `Hay ${nSounds} en esta palabra. Verás que hay ${nSounds} casillas en la pantalla. Mueve la primera bola roja a la primera casilla y di el primer sonido. Luego, mueve el resto de las bolas a las casillas y di cada sonido.`,
    intro_2:
      "Mira cómo muevo estas bolas a las casillas. Cada sonido tiene su propia casilla.",
    tutor_intro_part_1: "Aquí hay un juego de sonidos nuevo. Tengo una palabra con 3 sonidos. La palabra es", //TRANSLATE
    tutor_intro_part_2: "Voy a decir los 3 sonidos, y mover una bola roja a una caja para cada sonido. Mirame hacerlo primero. La palabra es", //TRANSLATE
    ignore_extras:
      "Puede haber más casillas que sonidos en la palabra. Simplemente ignora las que sobren",
    ask_word: `Ahora, junta esos sonidos y di la palabra.`,
    ask_sounds_1: ({ word }) => `Usa tu ${getSpanishInterface()} para mover las bolas a las cajas y di cada uno de los sonidos de la palabra ${word}.`,
    ask_sounds_2: `Usa tu ${getSpanishInterface()} para mover las bolas a las cajas y di los sonidos de la palabra que aparece en la imagen.`,
    your_turn: `Ahora es tu turno.`,
    your_turn_tutor: "Ahora es tu turno. La palabra es:", //TRANSLATE
    ask_blend: `Ahora, combina los sonidos para formar la palabra.`,
    correct: `Buen trabajo`,
    blend: `Ahora, combinaré los sonidos para formar la palabra`,
    describe_1: `La palabra`,
    describe_2: ({ nSounds }) => `tiene ${nSounds} sonidos.`,
    feedback_1:
      `Usa tu ${getSpanishInterface()} para mover una bola y di cada uno de los sonidos en`,
    feedback_2_part_1: `Los sonidos que forman la palabra`,
    feedback_2_part_2: `son`,
    struggle_part_1: `La palabra es`,
    struggle_part_2: `Continuemos.`,
    too_many_sounds: "Demasiados sonidos.",
    lets_work_on: ({ word }) => `Practiquemos la palabra ${word}`,
    the_sounds_are: "los sonidos en la palabra son", //TRANSLATE
    what_word: "que palabra hace los sonidos?", //TRANSLATE
    drag_the_circles: "mueva las bolas a las cajas", //TRANSLATE
  },
  cognate_intro: (word, cognate) =>
    `${word} es <lang xml:lang="es-ES">${cognate}</lang> en español.`,
  cognate_now_you_say_it: "Ahora, di tú la palabra en inglés.",
  name: {
    ask_sounds: `Vamos a pronunciar los sonidos que forman este nombre. Di el primer sonido y luego cada uno de los demás sonidos.`,
    intro_1_part_1: `Este es un`,
    intro_1_part_2: `nombre que significa`,
    intro_2: `es un famoso`,
    ask_word_1: `¡Genial! Ahora mueve tu ${getSpanishInterface()} sobre cada parte, de principio a fin, y di el nombre.`,
    ask_word_2: "Ahora, pronuncia tú este nombre.",
    correct_1: `Sí, este nombre se pronuncia`,
    correct_2: "Buen trabajo, gracias.",
    struggle_1_part_1: `Este nombre se pronuncia`,
    struggle_1_part_2: `Sigamos leyendo.`,
    fun_fact: `Aquí hay un dato curioso:`,
    lip_sync: "Mira cómo esta persona divide el nombre en varias partes.",
  },
  vocabulary_with_picture: {
    title: "Vocabulario con imágenes",
    intro: (descriptor) => `es una palabra ${descriptor}.`,
    question_text: '¿Qué imagen representa mejor la palabra?',
    correct_response: "¡Respondiste correctamente!",
    means: 'significa',
    descriptor: ["bastante difícil"],
  },
  sound_seeker: {
    intro: `Vamos a encontrar un sonido en`,
    describe_1: ({ isStart }) => `${isStart ? "comienza" : "termina"} con`,
    yes: "Sí",
    describe_2: ({ isStart }) => `también ${isStart ? "comienza" : "termina"} con`,
    ask_word: ({ isStart }) =>
      `${
        isTouchDevice() ? "toca" : "haz clic en"
      } la imagen que ${isStart ? "comienza" : "termina"} con`,
    correct: `Gracias por buscar los sonidos. Leamos un poco.`,
    no: "no",
    incorrect: ({ isStart }) => `no ${isStart ? "comienza" : "termina"} con`,
    its_this_one: "Es este.",
    like_word: 'al igual que',
  },
  prediction_question: {
    intro:
      'De acuerdo. Veamos cuán bien puedes adivinar qué sucede a continuación.<break time="0.5s"/> Piensa en la parte de la historia que hemos leído hasta ahora.',
    correct_response: "Buena predicción, estoy muy orgullosa de ti.",
    expire_right_answer: (answer) => `La respuesta correcta es: ${answer}.`,
    struggle: `Tratar de adivinar lo que sucederá es una parte importante de la lectura. Veamos qué pasa ahora. Sigue leyendo.`,
  },
  sound_out: {
    intro: `Voy a pronunciar los sonidos que forman esta palabra.`,
    ask_sounds: `Ahora es tu turno. Di cada sonido.`,
    ask_word: "¿Qué palabra forman?",
  },
  letter_flies: {
    intro: `Cuando me oigas decir un sonido, atrapa la mariposa que representa ese sonido. Para eso, ${
      isTouchDevice() ? "toca" : "haz clic en"
    } la mariposa con la letra que representa el sonido. <break time = "1s"/> Observa primero cómo lo hago.`,
    your_turn: `Ahora es tu turno.`,
    catch_butterfly: `Atrapa la mariposa que representa el sonido`,
    click_on: isTouchDevice() ? "toca" : "haz clic en",
    ask_sound_part_1: `Ahora, di el sonido`,
    ask_sound_part_2: `forma`,
    struggle: "¡Oh, no! La mariposa de esa letra se está escapando.",
    correct_1: "Atrapaste la mariposa de esa letra.",
    correct_2: `Así se atrapan las mariposas de las letras.`,
    tutor: {
      intro: "Cuando me oyes decir un sonido, atrapa la mosca que coincide con el sonido. Haces esto haciendo clic en la mariposa con la letra que coincide con el sonido. <break time=\"1s\"/> Mírame hacer esto primero.",
      on_no_click_action_1: `haga clic en la carta que hace que el`,
      on_no_click_action_2: `sonido.`,
      struggle: `Oh, no. La Flyfly está escapando, no te preocupes, nos atraparemos más tarde.`,
      your_turn_instruction_1: `Ahora es tu turno.`,
      your_turn_instruction_2: `tiene el`, // [word] has the [sound]
      your_turn_instruction_3: `sonido. ¿Qué carta hace`,
      your_turn_instruction_4: `¿sonido?`, // [sound] sound?
      silent_letter: ({targetGrapheme}) => `<speak><prosody rate="slow">${targetGrapheme}</prosody></speak>`,
      silent_instruction_1: `¿Puedes decir el sonido?`,
      silent_instruction_2: `¿marcas?`, // [sound] makes?
      silent_instruction_3: `hacer el`,
      silent_instruction_4: `<speak><break time="1s"/>sonido.</speak>`, // [sound]?
    },
  },
  say_a_sound: {
    intro: ({ nSounds }) =>
      `Observa la boca de esta persona pronunciando cada uno de los ${nSounds} sonidos que forman esta palabra.`,
    ask_sounds: `Ahora te mostraré la letra de cada sonido y tú pronunciarás el sonidos.`,
    ask_word: "Ahora, lee la palabra completa."
  },
  word_display: {
    intro: "Observa y escucha. Vamos a aprender más acerca de esta palabra,",
    ask_sound_part_1: `¿Cuál es el primer sonido en`,
    ask_sound_part_2: `?`,
    describe_part_1: `De acuerdo`,
    describe_part_2: `comienza con`,
    continue: `Sigamos leyendo.`,
  },
  up_and_down: {
    intro_1_intervention: `Mira cómo tu colega sube las escaleras mientras digo los sonidos que forman la palabra`,
    intro_1_tutor: `Voy a decir los sonidos en una palabra, y después voy a mezclarlos para hacer la palabra completa. Mirame primero`, //TRANSLATE
    intro_2: `Ayuda a tu colega a subir las escaleras diciendo los sonidos que forman la palabra`,
    ask_sounds_intervention: `Ahora, inténtalo tú. Di todos los sonidos que forman la palabra`,
    ask_sounds_tutor: `Ahora es tu turno. La palabra es`, //TRANSLATE
    ask_blend_intervention: "Combina los sonidos que forman la palabra.",
    ask_blend_tutor: "¿Cual palabra hacen los sonidos?", //TRANSLATE
    correct: `Buen trabajo.`,
    struggle_intro: `La palabra es`,
    struggle_end: `Leamos un poco más.`,
    prompt_sounds: '¿Puedes decir todos los sonidos en', //TRANSLATE
    repeat_after_me: `Repite después de mí`, //TRANSLATE
  },
  rhyming: {
    intro: `Aprendamos sobre esta palabra con unas rimas.`,
    describe: `Nuestra palabra rima con`,
    ask_word_1: `Lee esta palabra que rima con`,
    ask_word_2: `Ahora lee tú`,
    correct: "Ya dominas esta rima.",
    struggle: `Usemos la rima.`,
    rhymes_with: "rima con",
  },
  rhyming_quiz: {
    intro: "Es hora del juego de las rimas.",
    our_word_is: 'Nuestra palabra es',
    which_rhymes_with: '¿Cuál de estas palabras rima con',
    click_to_choose: () => `${
      isTouchDevice() ? "Toca" : "Haz clic en"
    } para elegir.`,
    you_are_right: 'Respondiste correctamente.',
    no: "No, ",
    doesnt_rhyme_with: "no rima con",
    but: "Pero",
    does: "sí",
    rhymes_with: 'rima con',
    back_to_reading: 'Sigamos leyendo.',
  },
  say_one_sound: {
    intro: "Observa y escucha mientras digo esta palabra",
    describe: ({ position }) =>
      `Voy a decir el ${position} sonido de la palabra`,
    ask_word: `Ahora es tu turno. Di la palabra`,
    struggle: `Vamos a trabajar en`,
    ask_sound: ({ position }) =>
      `Ahora, di el ${position} sonido de`,
    sound_is: "De acuerdo, el sonido es",
    correct: "Bien hecho.",
    first: "primer",
    last: "último",
  },
  word_investigator: {
    intro: ({ word }) =>
      `Observa esta palabra. Debería tener ${word.length} letras y ${word.length} sonidos. Pero faltan una letra y un sonido. Investiguemos.`,
    describe_1: ({ word }) => `tiene ${word.length} sonidos.`,
    describe_2: ({ word }) =>
      `Pero aquí solo hay ${word.length - 1} sonidos. El`,
    describe_3: ({ word }) =>
      `Busca la letra que corresponde al sonido que falta en la palabra ${word}.`,
    missing: "falta .",
    ask_letter: `${
      isTouchDevice() ? "Toca" : "Haz clic en"
    } la letra de la parte superior que representa el sonido que falta.`,
    correct_1: "Correcto. Hiciste una buena investigación.",
    correct_2: "Excelente, gracias.",
    struggle: `Ese no es el sonido de la letra que falta.`,
    try_again: `Vamos a intentarlo una vez más.`,
    give_answer_part_1: `La letra que falta es`,
    give_answer_part_2: `Ahora, lee la palabra.`,
    inactivity: `Inténtalo. ${
      isTouchDevice() ? "Toca" : "Haz clic en"
    } una letra en la parte de arriba.`,
  },
  give_and_take: {
    time_to_get_goofy: 'Es hora de jugar con la palabra',
    watch_and_listen: ({ isStart }) => `Observa y escucha mientras digo la ${isStart ? 'primera' : 'última'} parte de esta palabra.`,
    describe: ({ nSounds }) => `Esta parte de la palabra tiene ${nSounds} sonidos.`,
    ask_word_part: "Di la parte de la palabra conmigo.",
    correct_1: "¡Lo hiciste!",
    correct_2: `Continuemos.`,
    correct_3: "Bieh hecho.",
    ok_new_word_is: 'De acuerdo. Nuestra nueva palabra es',
    thanks: 'Gracias',
    struggle_1: "La parte de la palabra es ",
    struggle_2: "Ahora la palabra está en las casillas. Lee la palabra completa.",
    this_word_is: 'Esta palabra es',
    back_to_reading: 'Sigamos leyendo.',
    add_sound: ({ isStart }) =>
      `Ahora voy a añadir la ${isStart ? 'primera' : 'última'} parte de nuestra palabra. El sonido nuevo es`,
    word_is: "Ahora la palabra es",
    makes_word: "Eso forma la palabra",
    ask_sounds: ({ nSounds }) => `Ahora, repite los ${nSounds} sonidos.`,
    ask_word: `Ahora lee la palabra completa.`,
    replace_sound: `Ya solo falta el último paso. Reemplacemos un sonido. Vamos a cambiar el sonido`,
    to: "por",
    ask_sub: "Ahora pronuncia los sonidos que forman la palabra nueva.",
  },
  change_one_part: {
    intro: "Ahora jugaremos a intercambiar letras. Observa y escucha mientras pronuncio los sonidos que forman esta palabra.",
    change_one: `Voy a cambiar una letra en esta palabra. Al cambiar la letra, cambiará el sonido y se formará una palabra nueva.`,
    ask_word: "¿Puedes leer esta palabra?",
    another_swap: `Hagamos otro intercambio.`,
    correct: "Buen trabajo.",
    sound_out: `Pronunciemos los sonidos que forman esta palabra.`,
    good_job: `Buen intercambio de letras. Gracias.`,
    assessment_handle_intro: `Ahora jugaremos un juego de palabras. No leas hasta que yo te lo indique.`,
    assessment_handle_intro_say_word: 'Esta palabra es <break time="0.5s"/>',
    assessment_handle_intro_make_change: `Voy a cambiar una letra en esta palabra. Al cambiar la letra, cambiará el sonido y se formará una palabra nueva.`,
    assessment_handle_intro_prompt_to_try_transition: `Cuando las casillas se pongan amarillas, debes leer la palara nueva.`,
    assessment_handle_intro_prompt_to_try_read: 'Inténtalo: lee <break time="0.5s"/>',
    assessment_handle_intro_silence: 'Debes leer <break time="0.5s"/>',
    assessment_handle_silence: `¡Tú puedes! Lee la palabra nueva.`,
    assessment_handle_first_item_prompt: 'Bien, ahora jugaremos con la palabra <break time="0.5s"/>',
    assessment_handle_first_item_make_change: `Cambiemos una letra`,
    assessment_handle_first_item_prompt_to_read: `Es tu turno. Lee la palabra nueva.`,
    assessment_handle_nth_item_prompt: 'Bien, ahora jugaremos con la palabra <break time="0.5s"/>',
    assessment_handle_nth_item_make_change: `Cambiemos una letra`,
    assessment_handle_nth_item_prompt_to_read: `¿Cuál es la palabra?`,
    assessment_handle_item_done_try_another: `Buen intento. Vamos a probar con otras palabras.`,
    assessment_handle_end: `¡Muy bien! Gracias.`,
    end: "¡Gracias!",
    end_with_more_activities: "¡Gracias! Pasemos al siguiente conjunto de actividades.",
    tutor_example_intro: "Observa mientras pronuncio los sonidos que forman la palabra que aparece en la pantalla",
    tutor_example_change_one: `Voy a cambiar una letra en esta palabra. Al cambiar la letra, cambiará el sonido y se formará una palabra nueva.`,
    tutor_example_word: 'Esta palabra es <break time="0.5s"/>',
    tutor_example_ask_word: `Ahora inténtalo tú. Lee la palabra nueva.`,
    tutor_try_another_word: `Probemos con otra palabra.`,
    tutor_subsequent_item_instruction: ({word}) => `Esta palabra es <break time="0.5s"/> ${word}`,
    tutor_subsequent_item_change_one: `Cambiemos una letra`,
    tutor_subsequent_ask_word: `Lee la palabra nueva.`,
    tutor_example_intro_FTUE: "Juguemos a intercambiar letras. Observa cómo cambio un sonido por otro para formar una palabra nueva. La palabra es",
    tutor_example_change_one_FTUE: "Ahora cambio el sonido y mira: la palabra nueva es",
    tutor_silent_ask_word: `¿Puedes decir los sonidos en la nueva palabra?`,
    tutor_silent_end: `La palabra es`,
    non_ortho: {
      example: {
        we_are_now: `Ahora vamos a jugar un juego con palabras. Espera para hablar hasta que te haga saber que es hora.`,
        these_boxes_represent: `Estas tres cajas representan los tres sonidos en la palabra.`,
        those_sounds_are: `Esos tres sonidos son`,
        im_going_to_change: `Voy a cambiar un sonido en la palabra`,
        im_going_to_change_2: `Voy a cambiar el`,
        sound_to_the: `sonido para el`,
        sound_which_will_make: `sonido, que hará una nueva palabra.`,
        when_you_see_the_boxes: `Cuando vea que las cajas se vuelven amarillas, debe decir la nueva palabra que hace si cambio el`,
        in: `en`,
        to_a: `a un`,
      },
      subsequent: {
        now_lets_play_with: `Ahora jugemos con la palabra`,
        these_boxes_represent: `Estas tres cajas representan los tres sonidos en la palabra.`,
        those_sounds_are: `Esos tres sonidos son`,
        lets_change: `Ahora cambiemos el`,
        sound_to_the: `sonido para el`,
        sound: `sonido`,
      }
    }
  },
  word_scramble: {
    before_we_look_at: 'Antes de echarle un vistazo a',
    lets_talk_about: "hablemos sobre",
    sound_out: `Pronunciemos los sonidos que forman esta palabra.`,
    scrambled: "¡Oh, no! ¡Se desordenaron las letras! Mira cómo arreglo esta palabra.",
    fix_scrambled: `Para arreglar palabras desordenadas, usa tu ${getSpanishInterface()} para arrastrar las letras al lugar correcto.`,
    ask_unscramble: "Mueve las casillas para arreglar la palabra.",
    your_turn: "Es tu turno",
    ask_word_1: "Lee esta palabra.",
    ask_word_2: "Ahora, lee esta palabra.",
    this_is_our_word: 'Esta es nuestra palabra',
    unscrambled: 'en orden',
    lets_do_some_reading: "Leamos un poco.",
    you_got: 'Pusiste las letras de',
    back_in_order: 'en orden',
    fantastic_job: 'Hiciste un trabajo fantástico'
  }, /* end intervention library strings */


  comprehensionPrompt: [
    "Esta pregunta puede ser complicada. Haz clic en la respuesta que te parezca mejor.",
    "¿Qué respuesta tiene más sentido? Haz clic en una de las respuestas.",
  ],
  comprehensionWrongAnswer: [
    "¡Vaya! Esa no es la respuesta correcta. Inténtalo otra vez.",
    "Inténtalo otra vez. Esa respuesta es incorrecta.",
    "Oh, oh... esa no es la respuesta correcta.",
  ],
};



const EN_US_COPY_STRINGS = {
  //INTRODUCTION
  ready_to_start: "Ready to start?",
  lets_do_it: "Let's do it",
  ready: "Ready",
  set: "Set",
  start_bang: "Start!",
  and: "and",
  by: "by",
  or: "or",
  hello: "Hello",
  assigned_amira_intro: (tutorName) => `My name is ${tutorName}. Your teacher would like for you to read to me. Okay?`,
  amira_intro: (tutorName) => `My name is ${tutorName}.  I'd like to read with you today.`,
  great_to_see_you: "Great to see you",
  enter: "Enter",
  blank: "blank",

  //BADGE AWARD NOTIFICATION
  you_earned_badges: [`You've earned badges!`, `Since the last time we’ve read together, you’ve earned badges!`],
  im_awarding_you: ({badgeName}) => `I'm awarding you the ${badgeName} badge!`,
  and: "And...",
  to_see_your_badges: "To see your badges, see your progress. Now it's time to celebrate. Let's dance.",
  to_see_your_badges_early_reader: "Now it's time to celebrate. Let's dance.",
  you_are_badge_level: ({rewardLevelId}) => `You are a reading ${rewardLevelId}!`,
  badging_speed: "SPEED",
  badging_words: "Words",
  badging_correct: "CORRECT",
  badging_your_reading: "YOUR READING",
  badging_level: "Level",
  badging_next_be: "Next, be a",

  BADGE_TITLE: {
    NUM_SESSIONS: {
      'PAL': "5 Sessions",
      "BUDDY": "10 Sessions",
      "RANGER": "20 Sessions",
      "TITAN": "50 Sessions",
      "GURU": "75 Sessions",
      "WIZARD": "100 Sessions"
    },
    NUM_MINUTES: {
      "BUDDY": "20 Minutes a Week",
      "GURU": "30 Minutes a Week",
    },
    NEW_WCPM_HIGH: {
      'PAL': "10 Words a Minute",
      "BUDDY": "20 Words a Minute",
      "RANGER": "30 Words a Minute",
      "TITAN": "40 Words a Minute",
      "GURU": "60 Words a Minute",
      "WIZARD": "100 Words a Minute",
    },
    SKILLS_SCAFFOLD_GRADUATION: {
      'PAL': "First Skill",
      "GURU": "Graduated Skills",
    },
    NEW_HIGH: {
      "RANGER": "New High",
      "GURU": "New High x2",
      "WIZARD": "New High x3",
    },
    CUSTOM: {
      'PAL': "Custom",
      "BUDDY": "Custom",
      "RANGER": "Custom",
      "TITAN": "Custom",
      "GURU": "Custom",
      "WIZARD": "Custom"
    }
  },


  //STUDENT HISTORY
  you_read_stories_one: "You've read",
  you_read_stories_two: "stories with me and taken",
  you_read_stories_three: "tests.",
  you_usually_read_stats_one: "You usually read",
  you_usually_read_stats_two: "words every minute and get about",
  you_usually_read_stats_three: "percent of them right.",
  enjoy_reading_together: "I really enjoy our time reading together.",
  no_student_history: "We haven't red together yet. I'm looking forward to reading with you. Please come back after you've taken a test.", //Do not change this. Polly will mispronounce "read"
  nice_to_meet_you: "Nice to Meet You!",
  getting_history: "Getting your history",
  how_you_are_doing: "Here's how you're doing",
  progress: {
    stories: `stories`,
    welcome: [
      "Thanks for checking on our progress.",
      "Happy to tell you about your progress.",
      "Great news! We've made a lot of progress together.",
      "Lets show you all that you've accomplished."
    ],
    sessions: ({numberOfStories}) => [
      `So far, our stories red together total ${numberOfStories}.`,
      `Stories red so far is ${numberOfStories} stories.`,
      `Together, we've red ${numberOfStories} stories.`,
    ],
    sessions_estimated: ({numberOfStories}) => [
      `So far, our stories red together is more than ${numberOfStories}.`,
      `Stories red so far is more than ${numberOfStories} stories.`,
      `Together, we've red more than ${numberOfStories} stories.`,
    ],
    badges_earned: [
      `Badges earned:`,
      `Badges received:`,
      `Number of badges is `,
    ],
    metrics: [
      `Your average reading speed and accuracy are showing on the screen.`,
      `Your reading speed and accuracy are on screen.`
    ],
    praise: [
      `I like reading with you, so lets do it every day.`,
      `I hope we can keep reading together.`,
      `Thanks for being my reading `
    ],
    level: `And here's the best news of all. You are a reading`,
    next: [
      `If you keep reading with me, next up is`,
      `Keep reading, and you'll earn the next level:`,
      `Your next award is`
    ]
  },


  //VOICE PICKER OPTIONS
  ive_selected_x_stories: (numStories) => `I've selected ${numStories} stories for you:`,
  which_story: (readAloud) => `Which story would you like to ${readAloud ? 'hear' : 'read'}?`,
  id_like_you_to_read: "I'd like you to read:",
  click_story_to_start: "Click or say the name of the story when you're ready to start",
  no_stories_speech: "I'm sorry, something went wrong. There are no stories for you",
  no_stories_text: "There are no Stories to Display",
  kindergarten: "Kindergarten",
  first_grade: "First Grade",
  second_grade: "Second Grade",
  third_grade: "Third Grade",
  what_grade: "What grade are you in?",
  didnt_understand: "I'm sorry, I didn't understand that.",
  what_activity_today: "What would you like to do today?",
  what_activity_next: "What would you like to do next?",
  take_a_test: "Take a test",
  take_a_test_speech: "take a test",
  read_a_story: "Read a story",
  read_a_story_speech: "reed a story to me",
  read_a_story_in_spanish: "Leer una historia en español",
  read_a_story_in_spanish_speech: "léeme una historia en español",
  see_progress: "See progress",
  see_progress_speech: "see your progress",
  no_activities_speech: "Your teacher hasn't assigned you any activities.",
  would_you_like: "Would you like to",
  loading: "Loading",

  //ASSESSMENT INSTRUCTIONS
  orf_instructions: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this story aloud for me. Read until you reach the end of the story or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started!",
  orf_with_page_navigation_instructions: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this story aloud for me. When you reach the end of a page, use the arrow button to move on. Read until you reach the end of the story or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started!",
  dyslexia_instructions: "We're going to start off with a few short reading activities. Please wait for me to give you instructions for each part, then I'll listen to you read. Please read loudly and clearly. Let's get started!",
  nwf_instructions:  "When you don't know a word, you try to sound it out. In the next section we are going to practice that by reading words that aren't real, but could be. For each one, put the different sounds the letters make together to form a complete word.",
  spelling_intro:  "In this section we are going to work on spelling.",
  listening_comprehension_intro:  "My friend is going to read you a story. Let’s listen carefully together. After the story I’ll ask you a few questions.",
  reading_comprehension_intro:  "Great job reading! Now I have a few questions about that story. I'll read the question and each of the answers. Try your best!",
  vocabulary_screener_intro: "For this next activity, I want you to choose the word that best fits. I will read the words to you.",
  abbreviated_instructions: "Skipping Instructions",
  relevel_instructions: "Ok, let's get ready to read again. Please read loudly and clearly. If you get to a word that you do not know, remember that you may skip it. I'm going to count down and then you can start reading.",
  next_section_transition: "Great job on that part! Now we're going to try something else.",
  please_wait: (tutorName) => `Please wait until ${tutorName} tells you to start`,
  end_assessment: "END ASSESSMENT",
  try_different_story: "I think we should try switching to a different story.",
  please_keep_reading: "You're not finished yet, please keep reading.",

  // ASSESSMENT - Word part deletion
  word_part_deletion: {
    intro_instruction: ({word, omit, target}) => `We're going to say some mystery words to Spot. I'm going to say a long word, and then give you a part of that word you should not say. For example, I would tell you to say ${word} without saying ${omit}. You would then say ${target}. Can you say ${word} without saying ${omit}?`,
    intro_end: "Great!  Spot will bark when he hears you.",
    actual_instruction: ({word, omit}) => `Please say the word ${word} without ${omit}.`,
    prompt_to_try: ({word, omit}) => `You can do it, please say ${word} without ${omit}`,
    end: "Thank you!",
    end_with_more_activities: "Thank you!  Let's move on to the next set of activities.",
  },

  // ASSESSMENT - Nonsense word repetition
  nonsense_word_repetition: {
    "intro": ({modelName, nonsenseWord}) => `Here’s ${modelName}! ${modelName} is going to say some words that aren’t real words like ${nonsenseWord}`,
    "intro_prompt": ({modelName, nonsenseWord}) => `Please say ${nonsenseWord} to ${modelName}.`,
    "intro_end": ({modelName, nonsenseWord}) => `Great job! Now ${modelName} is going to say some more words that aren’t real words. You should say them back to ${modelName} and me, just like you repeated ${nonsenseWord}. If you want ${modelName} to say the words again, just press the big replay button.`,
    "prompt_to_try": ({modelName}) => `If you want ${modelName} to repeat the word, press the replay button.`,
    "subsequent_prompt_to_try": "You can do it! Give it a try.",
    "subsequent_end": "Got it!",
    "end": "Got it, thanks!",
    "end_with_more_activities": "Thank you!  Let's move on to the next set of activities.",
  },

  //INTERVENTIONS
  keep_reading: "Let's keep reading!",
  try_again: "let's try that again",
  start_reading: "Please start reading",
  wordAttackPrompt: [
    "Do you know the first sound in this word?",
    "Can you sound out this word?",
  ],

  //STATUS STRINGS
  onFire: [
    "Really good job.",
    "That's great reading.",
    "Amazing job.",
    "You are on fire.",
    "Super job, reading.",
    "Way to go.",
    "You did a wonderful job.",
    "Good progress, pal.",
  ],
  goodAccuracy: [
    "That was nice reading.",
    "Appreciate how clearly you red.", //Do not change this. Polly will mispronounce "read"
    "I think you red pretty accurately today.", //Do not change this. Polly will mispronounce "read"
    "Way to go -- you got a lot of words right.",
    "Very few mistakes.  Nice work.",
    "You red a lot of hard words right.", //Do not change this. Polly will mispronounce "read"
    "Nice reading today.",
  ],
  workOn: [
    "We'll work on doing better.",
    "I know you can improve.",
    "Keep working hard.",
    "We can do even better next time.",
    "If we keep reading together, you'll get even more right.",
    "Let's keep at this.",
    "I hope you will keep reading with me.",
    "Keep at it.",
  ],
  goodSpeed: [
    "You were reading at a nice speed.",
    "Appreciate how you red through this story.", //Do not change this. Polly will mispronounce "read"
    "You red at a good pace today.", //Do not change this. Polly will mispronounce "read"
    "You're a quick reader.",
    "Nice job reading so smoothly.",
    "You red nice and fast today.", //Do not change this. Polly will mispronounce "read"
    "Today, you red nice and fast.", //Do not change this. Polly will mispronounce "read"
  ],
  wrapUp: [
    "Thanks for reading together.",
    "Thank you for reading to me.",
    "I enjoyed reading together.",
    "Appreciate you spending time reading.",
    "Thank you.",
    "Great reading with you.",
    "Appreciate you reading with me.",
  ],
  keep_up: "Keep up the good work!",
  status_stats_speech_front: (wcpm, accuracy) => `You red ${wcpm} words each minute and got ${accuracy} percent of them right`, //Do not change this. Polly will mispronounce "read"
  stats_compare_improved: (wpmDifference, accuracyDifference) => `That's ${wpmDifference} words faster and ${accuracyDifference} percent more accurate than usual.`,
  stats_compare_improved_wpm: (wpmDifference) => `That's ${wpmDifference} words faster than usual.`,
  stats_compare_improved_accuracy: (accuracyDifference) => `That's ${accuracyDifference} percent more words right than usual.`,
  times_up_speech: "Your time is up. Great work!",
  finished_story_speech: "Great work, you finished the story!",
  finished_assessment_speech: "Great work, you are all finished.  I'm going to log you out so you can move on with your day. Thank you.",
  all_done_speech: "Great work! You're all done.",
  stats_speech_one: "You red",  //Do not change this. Polly will mispronounce "read"
  stats_speech_two: "words each minute and got",
  stats_speech_three: "percent of them right.",
  stats_speech_compare_improved: (wpmDifference) => `You red this story ${wpmDifference} words faster than usual and with higher accuracy.`, //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_wpm_one: "You red this story", //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_wpm_two: "words faster than usual. Your accuracy was",
  stats_speech_compare_improved_wpm_three: "percent.",
  stats_speech_compare_improved_accuracy_one: "You red this story with", //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_accuracy_two: "percent higher accuracy than usual.",
  even_better: "We can work together to get even better.",
  work_to_get_better: "We can work together to get better.",
  times_up: "Time's Up",
  finished_story: "You Finished the Story",
  all_done: "All Done",
  speed: "Speed",
  average_speed: "Average Speed",
  correct: "Correct",
  average_correct: "Average Correct",
  great_work: "Great work!",

  //GENERAL DISPLAY
  example: "example",
  go_to_the: "Go To The",
  tracking_report: "Tracking Report",
  recommendation_intervention: "Catch Up",
  recommendation_catch_up: "On Track",
  recommendation_at_above: "At/Above",
  print_letters: "Print Letters",

  //ERROR MODALS
  audio_error_speech: "I'm having trouble understanding you, so we'll have to start over. Please make sure that your microphone is unmuted and that you are speaking loudly and clearly. When you are ready to try again, click the 'restart' button",
  error_speech: "I'm sorry, an error has occured so we'll have to start over. When you are ready to try again, click the 'sign out and restart' button",
  mute_error_speech: "It looks like your microphone is muted. Please unmute and then click 'I'm Ready' to continue",
  disabled_error_speech: "It looks like you have not enabled access to your microphone. Please enable your microphone and then click the button to continue",
  kid_error_speech: "Oops! We need help! Raise your hand so that your teacher will come help us.",
  error_text: "I'm sorry, but something went wrong and I will need to restart your assessment.",
  mute_error_text: "It looks like you're on mute. Please make sure that your microphone is unmuted, then click the button below to begin",
  audio_error_text: "I can't understand you. Please make sure that your microphone is unmuted and that you are speaking loudly and clearly",
  compat_error_text: "It looks like your browser is not supported, or is out of date. Please update to Chrome 70 or higher in order to read.",
  compat_error_text_os: "It looks like your operating system is not supported, or is out of date.",
  compat_error_no_spanish: "Your browser does not support Spanish practice. Hit 'I'm ready' to go back to the main menu",
  compat_error_text_mobile: "It looks like your mobile device is not supported.",
  compat_error_text_ipad: "It looks like your browser is not supported, or is out of date. Please update to iOS 12 or higher in order to read.",
  disabled_error_continue: "It looks like you have not enabled access to your microphone. Please enable microphone access for this web page to continue.",
  disabled_error_text: "It looks like you have not enabled access to your microphone. Please log back in and select Allow when asked for the microphone.",
  blank_error_text: "I'm having trouble listening to your speech. Please hit Logout to refresh your browser. You will need to log in again",
  ipad_error_text: (brandedAppName) => `${brandedAppName} for Teachers is not currently supported on iPad. To continue as a student, click OK and then log back in with student credentials.`,
  raise_your_hand: "Raise Your Hand",
  logout: "Logout",
  im_ready: "I'm ready",
  restart: "Restart",
  logout_and_restart: "Logout and restart",
  browser_not_supported: "Your browser is not supported",
  os_not_supported: "Your operating system is not supported",
  mobile_not_supported: "Your mobile device is not support",
  wait_modal_text: "Please wait while I save your reading",
  scoring_wait_modal_text: "Please wait while I save your scored activity",
  wait_modal_title: "Saving",
  no_stories_for_you: "You've read all the stories that are available to you. Please raise your hand and ask the teacher to help.",
  no_stories_for_you_text: "All the stories for this screening window have been taken. The student can continue to read non-assessment stories",
  all_stories_taken: "No available stories",
  play_video_with_button: "Please click on the play button to start.",
  error_fetching_stories: "Oops! I couldn't find your stories. Press the big green button to try again.",
  error_fetching_stories_rec_code: "Error code 0001: We're having trouble retrieving your stories. Please try again or contact support for further help.",
  error_fetching_stories_story_code: "Error code 0002: We're having trouble retrieving your stories. Please try again or contact support for further help.",
  error_fetching_stories_put_activity_code: "Error code 0003: We're having trouble retrieving your stories. Please try again or contact support for further help.",
  error_fetching_stories_title: "Oops! I couldn't find your stories.",
  try_again: "Try Again",
  paused_from_bad_network_speech: "Uh oh. There is a problem with your internet. Let me try to reconnect.",
  paused_from_bad_network_title: "Oops!",
  resume_from_bad_network_ready: "Ready!",
  resume_from_bad_network_speech: "We're back! Press go when you are ready and start reading.",
  resume_from_bad_network_continue: "Go",
  retry_pause_network_speech: "I'm still having trouble. Let's count to three and then try again.",
  retry_pause_network_title: "Uh oh!",
  retry_pause_network_button: "Try Again",
  critical_network_speech: "Let's ask your teacher for help. Please raise your hand.",

  //TUTOR
  read_with_me_mode: "Let's read some of this story together. I will read each phrase to you. After I have finished, you should try the phrase on your own.",
  end_read_with_me_mode: "Ok, I'll read one more phrase for you. After this phrase, you can read to me.",
  intervention_strings: EN_US_INTERVENTION_STRINGS,
  student_checks: {
    intro: "You're finally here!",
    intro_triple_yes: "Yes yes yes yes yes!!!!",
    intro_excited: "I’m so excited!",
    intro_continued: 'I feel like I`ve been waiting FOREVER to read with you!',
    intro_finished: (tutorName) => `Hi, I'm ${tutorName}!`,
    intro_microphone: "Sooo, how’s it going?<break time=\"1.5s\"/>",
    welcome_back: "Welcome back!",
    wait_while_i_check: "Please wait while I check a few things.",
    microphone_access_granted: "Let’s get this reading party started!?<break time=\"1s\"/>",
    intro_amira_moveon_one: "Okay okay. You’re not just here to dance – you’re here to READ!",
    intro_amira_moveon_two: "I’m YOUR personal reading tutor",
    intro_amira_moveon_three: "and I'm going to help you become a great reader! And guess what!?",
    intro_screen: "This screen will let us read ANY story we want, and I’ll help you along the way.<break time=\".5s\"/>",
    intro_assessment_mode: "Let's make sure I can hear you so we can start!",
    volume_check_intro_one: "We’re going to meet all kinds of great characters.", // glance
    volume_check_intro_two: "But don’t just take my word for it, I’ll show you! This...",
    check_on_spot_intro: "is one of my favorite story characters!", // mid range point at 3 o clock
    check_on_spot_intro_part_two: "Let’s check out my buddy Spot!<break time=\"1s\"/>",
    oh_hes_sleeping: "Oh! He’s sleeping", // wide eyed animation
    lets_wake_him_up_one: "Let’s wake him up! We need to talk loud enough for him to hear us,", //pointdown
    talk_loud_enough: "We need to talk loud enough for him to hear us,",
    lets_wake_him_up_two: "but not SO loud that we scare him",
    lets_wake_him_up_three: "When this microphone turns green",
    wake_up_spot: "say Wake up, Spot!",
    he_heard_you: "He heard you! That’s exactly how you should do it when you’re reading with me. ", // excited //waves
    he_heard_you_loud: "Okay, I think Spot can hear you.",
    he_heard_you_two: "Well Spot, it’s been real, later!",
    finish_asr_check: "Perfect! This is gonna be great!", // thumbs up
    handle_too_soft_one: "Hmm....He couldn't hear you, when the mic turns green, say it again louder, \"Wake up, Spot\" <break time=\"1.5s\"/>",
    handle_too_soft_second_round: "Err, he still couldn't hear you! <break time=\"1.5s\"/>",
    handle_too_soft_second_round_two: "Is the microphone in front of your mouth? Can you make sure it is?<break time=\"1.5s\"/>",
    handle_too_soft_second_round_three: "Are you speaking in a loud, proud voice?",
    handle_too_soft_second_round_four: "Try to wake him up again.",
    handle_too_loud_one: "Whoa! We don't want to scare him! <break time=\"1.5s\"/>",
    handle_too_loud_two: "Is the microphone TOUCHING your mouth? Can you move it away a little bit?<break time=\"1.5s\"/>",
    handle_too_loud_three: "Now speaking a little bit softer, say Wake up, Spot! <break time=\"1.5s\"/>",
    handle_no_audio_one: "uhhh, I couldn't hear you! If you're using a headset, try pressing the button on your cord to unmute.<break time=\"2s\"/>",
    handle_no_audio_part_two: "when the microphone turns green, in a loud, proud voice",
    handle_no_audio_two: "I still can't hear you. Let's try one more thing. Let's leave and come back. Can you close out of the app and then start over again. I'll see you when you get back!<break time=\"1s\"/>",
    handle_get_teacher: "Let’s get your teacher to help us. Please raise your hand.",
    handle_get_teacher_two: "Can you raise your hand to get your teacher to help?",
    teacher_mode_volume_welcome_one: "Thanks for coming to help. I can't hear the student reading. Can we see if I can hear you, please say, \"Wake up, Spot\"",
    teacher_mode_volume_success_one: "Great! I can hear you. Can you please make sure the student is close to the microphone and using a clear and loud voice.",
    teacher_mode_volume_student_retry: "Please let the student try again.",
    teacher_mode_volume_success_but_loud_one: "It still sounds loud on my end. Can you talk quieter or adjust the volume on the microphone and have the student try again?",
    teacher_mode_volume_failure_one: "Oh no! I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
    network_ping_error: "You're finally here! I’m so excited! Um…looks like there's a problem with the Internet.",
    return_user_wake_up_prompt: "Can you wake up my buddy, Spot? <break time=\"1s\"/>",
    return_user_talk_loud_enough: "We need you to talk loud enough to wake him up.",
    student_hardware_denied: "Hmm, sounds like there's a problem with the microphone.",
    student_hardware_denied_two: "Let’s get your teacher to help us. Please raise your hand.<break time=\"1s\"/>",
    student_hardware_prompt_intro: "Ah! I almost forgot! You have to turn your MICROPHONE on so I can hear you.",
    student_hardware_prompt_initial: "Just tap “Allow” and we can get started!",
    student_hardware_prompt: "You can do it! Tap Allow so we can start!",
    student_hardware_prompt_two: "Are you still there? Tap the button on the right that says Allow.",
    student_hardware_manually_fixed: "Thanks! Just close down and restart. See you in a minute.",
    prompt_ios_device_mic_modal_error: "Nope. Tap the button on the right that says allow",
    prompt_ios_device_mic_modal_success: "Tap it again, one more time",
    prompt_ios_device_mic_modal_got_it: "you got it!",
    student_asr_initial_prompt: "Go ahead and say -- I'm Ready to Start!",
    student_asr_reminder_one: "I didn't hear you, please say -- I'm ready to start.",
    student_asr_reminder_two: "Can you try again? Speak into the microphone and say, \"I'm ready to start\"",
    student_asr_reminder_three: "I still can't hear anything. Can you please say, \"I'm ready to start\".",
    student_asr_get_teacher: "Let’s get your teacher to help us. Please raise your hand.",
    teacher_mode_asr_initial_prompt_one: "Thanks for coming to help. I can't hear the student reading. Can we see if I can hear you?",
    teacher_mode_asr_initial_prompt_two: "Can you please say, \"I'm ready to start\"",
    teacher_mode_asr_reminder_one: "I couldn't hear you. Can you try again? When the microphone turns green say, \"I'm ready to start.\"",
    teacher_mode_asr_success: "Great! It sounds like I can hear you.",
    teacher_mode_asr_failure_flagging_prompt_one: "Do you have trouble understanding this student's speech?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "I understand. I will make some adjustments for this particular student. Please make sure they have a quiet space and the microphone close to their mouth.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Okay- please make sure your student puts the microphone close to their mouth and speaks with a clear and loud voice.",
    teacher_mode_asr_failure_high_bgn_one: "I am hearing a lot of background noise. Please help the student find a quieter space. Also, remind them to use a loud and clear voice into the microphone.",
    teacher_mode_asr_failure_none_worked_one: "Oh no! I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
  }
}

const ES_MX_COPY_STRINGS = {
  //INTRODUCTION
  ready_to_start: "¿Podemos comenzar?",
  lets_do_it: "¡Vamos",
  ready: "En sus marcas",
  set: "listos",
  start_bang: "¡fuera!",
  and: "y",
  by: "por",
  or: "o",
  hello: "Hola",
  assigned_amira_intro: (tutorName) => `Me llamo ${tutorName}. Tu docente quiere que leas para mí. ¿De acuerdo?`,
  amira_intro: (tutorName) => `Me llamo ${tutorName}. Me gustaría leer contigo hoy`,
  great_to_see_you: "¡Qué bueno verte",
  enter: "Intro",
  blank: "en blanco",

  //BADGE AWARD NOTIFICATION
  you_earned_badges: [`¡Has ganado insignias!`, `Desde la última vez que leímos, ¡has ganado insignias!`],
  im_awarding_you: ({badgeName}) => `¡Te otorgo la insignia ${badgeName}!`,
  and: "Y...",
  to_see_your_badges: "Para ver tus insignias, consulta tu progreso. ¡Es hora de celebrar! ¡Bailemos!",
  to_see_your_badges_early_reader: "¡Es hora de celebrar! ¡Bailemos!",
  you_are_badge_level: ({rewardLevelId}) => `¡Estás leyendo como un ${rewardLevelId}!`,
  badging_speed: "VELOCIDAD",
  badging_words: "Palabras",
  badging_correct: "CORRECTO",
  badging_your_reading: "TU LECTURA",
  badging_level: "Nivel",
  badging_next_be: "Ahora, conviértete en un",
  BADGE_TITLE: {
    NUM_SESSIONS: {
      'PAL': "5 sesiones",
      "BUDDY": "10 sesiones",
      "RANGER": "20 sesiones",
      "TITAN": "50 sesiones",
      "GURU": "75 sesiones",
      "WIZARD": "100 sesiones"
    },
    NUM_MINUTES: {
      "BUDDY": "20 minutos por semana",
      "GURU": "30 minutos por semana",
    },
    NEW_WCPM_HIGH: {
      'PAL': "10 palabras por minuto",
      "BUDDY": "20 palabras por minuto",
      "RANGER": "30 palabras por minuto",
      "TITAN": "40 palabras por minuto",
      "GURU": "60 palabras por minuto",
      "WIZARD": "100 palabras por minuto",
    },
    SKILLS_SCAFFOLD_GRADUATION: {
      'PAL': "Primera habilidad",
      "GURU": "Habilidades dominadas",
    },
    NEW_HIGH: {
      "RANGER": "Nuevo récord de puntuación",
      "GURU": "Nuevo récord de puntuación x2",
      "WIZARD": "Nuevo récord de puntuación x3",
    },
    CUSTOM: {
      'PAL': "Costumbre",
      "BUDDY": "Costumbre",
      "RANGER": "Costumbre",
      "TITAN": "Costumbre",
      "GURU": "Costumbre",
      "WIZARD": "Costumbre"
    }
  },

  //STUDENT HISTORY
  you_read_stories: (numberOfStories, numberOfTests) => `Has leído ${numberOfStories} historias conmigo y has tomado ${numberOfTests} pruebas.`,
  you_usually_read_stats: (avgWPM, avgAccuracy) => `Por lo general, lees ${avgWPM} palabras por minuto y pronuncias el ${avgAccuracy} por ciento correctamente`,
  no_student_history: "Todavía no he leído contigo, pero tengo muchas ganas de hacerlo. Regresa después de tomar una prueba.",
  nice_to_meet_you: "¡Me alegra conocerte!",
  getting_history: "Estoy buscando tu historial",
  how_you_are_doing: "Mira tus resultados",
  enjoy_reading_together: "Disfruto mucho de nuestro tiempo de lectura juntos.",

  progress: {
    stories: `historias`,
    welcome: [
      "Gracias por verificar nuestro progreso.",
      "Me complace informarte de tu progreso.",
      "¡Buenas noticias! Hemos progresado mucho.",
      "Te mostraré todo lo que has logrado."
    ],
    sessions: ({numberOfStories}) => [
      `Hasta ahora, hemos leído ${numberOfStories} historias en total.`,
      `Hasta ahora hemos leído ${numberOfStories} historias.`,
      `Hemos leído ${numberOfStories}.`,
    ],
    sessions_estimated: ({numberOfStories}) => [
      `Hasta ahora hemos leído más de ${numberOfStories} historias.`,
      `Hasta el momento hemos leído más de ${numberOfStories} historias.`,
      `Hemos leído más de ${numberOfStories} historias.`,
    ],
    badges_earned: [
      `Insignias ganadas:`,
      `Insignias recibidas:`,
      `El número de insignias es`,
    ],
    metrics: [
      `La pantalla muestra tu velocidad y precisión promedio de lectura.`,
      `La pantalla muestra tu velocidad y precisión de lectura.`
    ],
    praise: [
      `Me gusta leer contigo, me encantaría leer contigo todos los días.`,
      `Espero seguir leyendo contigo.`,
      `Gracias por ser mi`
    ],
    level: `Y aquí está la mejor parte, eres un`,
    next: [
      `Si sigues leyendo conmigo, el siguiente nivel será el`,
      `Sigue leyendo y pasarás al siguiente nivel:`,
      `Tu próximo premio es`
    ]
  },

  //VOICE PICKER OPTIONS
  ive_selected_x_stories: (numStories) => `He seleccionado ${numStories} historiass para ti:`,
  which_story: (readAloud) => `¿Qué historia te gustaría ${readAloud ? 'escuchar' : 'leer'}?`,
  id_like_you_to_read: "Me gustaría que leyeras:",
  click_story_to_start: "Para comenzar, haz clic en el título de la historia o dilo en voz alta",
  no_stories_speech: "Lo siento, algo no salió bien. No hay ninguna historia para ti",
  no_stories_text: "No hay historias para mostrar",
  kindergarten: "Kínder",
  first_grade: "Primer grado",
  second_grade: "Segundo grado",
  third_grade: "Tercer grado",
  what_grade: "¿En qué grado estás?",
  didnt_understand: "Lo siento, no entendí eso.",
  what_activity_today: "¿Qué te gustaría hacer hoy?",
  what_activity_next: "¿Qué te gustaría hacer a continuación?",
  take_a_test: "Tomar una prueba",
  take_a_test_speech: "Toma una prueba",
  read_a_story: "Leer una historia en inglés",
  read_a_story_speech: "Léeme una historia en inglés",
  read_a_story_in_spanish: "Leer una historia en español",
  read_a_story_in_spanish_speech: "Léeme una historia en español",
  see_progress: "Ver tu progreso",
  see_progress_speech: "Mira tu progreso",
  no_activities_speech: "Tu docente no te ha asignado ninguna actividad.",
  would_you_like: "¿Te gustaría",
  loading: "Cargando",


//ASSESSMENT INSTRUCTIONS
  orf_instructions: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas esta historia en voz alta. Lee hasta terminar la historia o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!",
  orf_with_page_navigation_instructions: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas esta historia en voz alta. Cuando llegues al final de una página, usa el botón de flecha para continuar. Lee hasta terminar la historia o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!",
  dyslexia_instructions: "Empezaremos con unas actividades de lectura cortas. Espera a que te dé las instrucciones para cada parte. Después te escucharé leer. Recuerda hablar alto y claro. ¡Comencemos!",
  nwf_instructions:  "Cuando no conozcas una palabra, intenta pronunciar sus sonidos. En la siguiente sección, practicaremos esto con palabras que no son reales, pero que podrían serlo. Tendrás que unir los diferentes sonidos que hacen las letras para formar una palabra completa.",
  spelling_intro:  "En esta sección, trabajaremos con la ortografía.",
  listening_comprehension_intro:  "Escucha con atención la siguiente historia. Al final, te haré algunas preguntas.",
  reading_comprehension_intro:  "¡Leíste muy bien! Ahora te haré algunas preguntas sobre esa historia. Leeré la pregunta y las opciones de respuesta. ¡Intenta responder lo mejor que puedas!",
  vocabulary_screener_intro: "En la siguiente actividad, quiero que elijas la palabra más adecuada. Te leeré las palabras.",
  abbreviated_instructions: "Instrucciones para saltar palabras",
  relevel_instructions: "Ahora vamos a prepararnos para leer otra vez. Debes hablar alto y claro. Si te topas con una palabra que no conoces, recuerda que puedes saltarla. Comenzaré la cuenta regresiva para que empieces a leer.",
  next_section_transition: "¡Buen trabajo en esa parte! Ahora intentaremos algo distinto.",
  please_wait: (tutorName) => `Por favor, espera a que ${tutorName} te indique que puedes comenzar`,
  end_assessment: "CONCLUIR LA EVALUACIÓN",
  try_different_story: "Creo que debemos intentarlo con una historia diferente.",
  please_keep_reading: "Aún no has terminado, sigue leyendo.",

  // ASSESSMENT - Word part deletion
  word_part_deletion: {
    intro_instruction: ({word, omit, target}) => `Le diremos a Spot varias palabras misteriosas. Yo mencionaré una palabra larga y te indicaré una parte de esa palabra que no debes decir. Por ejemplo, te pediré que repitas la palabra ${word} sin decir ${omit}. Luego, tú dirás ${target}. ¿Puedes repetir la palabra ${word} sin decir ${omit}?`,
    intro_end: "¡Excelente! Spot ladrará cuando te escuche.",
    actual_instruction: ({word, omit}) => `Repite la palabra ${word} sin decir ${omit}.`,
    prompt_to_try: ({word, omit}) => `¡Tú puedes! Repite la palabra ${word} sin decir ${omit}`,
    end: "¡Gracias!",
    end_with_more_activities: "¡Gracias! Pasemos al siguiente grupo de actividades.",
  },

  // ASSESSMENT - Nonsense word repetition
  nonsense_word_repetition: {
    intro: ({modelName, nonsenseWord}) => `¡Te presento a ${modelName}! ${modelName} dirá algunas palabras que no son reales, como ${nonsenseWord}`,
    intro_prompt: ({modelName, nonsenseWord}) => `Repítele la palabra ${nonsenseWord} a ${modelName}.`,
    intro_end: ({modelName, nonsenseWord}) => `¡Buen trabajo! Ahora ${modelName} dirá más palabras que no son reales. Tú nos las repetirás a ${modelName} y a mí como hiciste con la palabra ${nonsenseWord}. Si quieres que ${modelName} vuelva a decir las palabras, presiona el botón grande.`,
    prompt_to_try: ({modelName}) => `Si quieres que ${modelName} repita la palabra, presiona el botón.`,
    subsequent_prompt_to_try: "¡Tú puedes! Inténtalo.",
    subsequent_end: "¡Muy bien!",
    end: "¡Muy bien! Gracias.",
    end_with_more_activities: "¡Gracias! Pasemos al siguiente grupo de actividades.",
  },

  //INTERVENTIONS
  keep_reading: "¡Sigamos leyendo!",
  try_again: "Vamos a intentarlo otra vez",
  start_reading: "Comienza a leer",
  wordAttackPrompt: [
    "¿Conoces el primer sonido de esta palabra?",
    "¿Puedes pronunciar los sonidos que forman esta palabra?",
  ],

  //STATUS STRINGS
  onFire: [
    "¡Hiciste un excelente trabajo!",
    "¡Leíste muy bien!",
    "¡Buen trabajo!",
    "¡No hay quien te detenga!",
    "¡Qué bien leíste!",
    "¡Bien hecho!",
    "¡Hiciste un trabajo fantástico!",
    "¡Vas muy bien!",
  ],
  goodAccuracy: [
    "Leíste muy bien.",
    "Leíste muy claro. ¡Te felicito!",
    "Hoy leíste con mucha precisión.",
    "¡Bien hecho! Leíste correctamente muchas palabras.",
    "Cometiste muy pocos errores. ¡Buen trabajo!",
    "Leíste correctamente muchas palabras difíciles.",
    "Hoy leíste muy bien.",
  ],
  workOn: [
    "Seguiremos trabajando para mejorar.",
    "Sé que puedes mejorar.",
    "Sigue esforzándote.",
    "La próxima vez, lo haremos aún mejor.",
    "Si sigues leyendo conmigo, lo harás cada vez mejor.",
    "¡Sigamos practicando!",
    "Espero que sigas leyendo conmigo.",
    "Sigue practicando."
  ],
  goodSpeed: [
    "Leíste a buena velocidad.",
    "Aprecio que hayas leído esta historia.",
    "Hoy leíste a un buen ritmo.",
    "Leíste rápido.",
    "Leíste con fluidez.",
    "Hoy leíste bien y rápido.",
    "Hoy leíste muy bien y rápido.",
  ],
  wrapUp: [
    "Gracias por leer conmigo.",
    "Gracias por leerme eso.",
    "Me encantó leer contigo.",
    "Gracias por sacar tiempo para leer.",
    "Gracias.",
    "¡Me gustó mucho leer contigo!",
    "Gracias por leer conmigo.",
  ],
  keep_up: "¡Sigue así!",
  status_stats_speech_front: (wcpm, accuracy) => `Leíste ${wcpm} palabras por minuto y pronunciaste correctamente el ${accuracy} por ciento de ellas`,
  stats_compare_improved: (wpmDifference, accuracyDifference) => `Leíste ${wpmDifference} palabras más rápido con una precisión un ${accuracyDifference} por ciento mayor en comparación con tus resultados habituales.`,
  stats_compare_improved_wpm: (wpmDifference) => `Leíste ${wpmDifference} palabras más rápido que lo habitual.`,
  stats_compare_improved_accuracy: (accuracyDifference) => `Leíste correctamente un ${accuracyDifference} por ciento más que lo habitual.`,
  times_up_speech: "Se acabó el tiempo. ¡Excelente trabajo!",
  finished_story_speech: "Buen trabajo, ¡terminaste la historia!",
  finished_assessment_speech: "Buen trabajo, ya terminaste. Voy a desconectarte para que puedas continuar con tu día. Gracias.",
  all_done_speech: "¡Buen trabajo! Ya terminaste.",
  stats_speech_one: "Leíste",
  stats_speech_two: "palabras por minuto y pronunciaste correctamente un",
  stats_speech_three: "por ciento de ellas.",
  stats_speech_compare_improved: (wpmDifference) => `Leíste esta historia ${wpmDifference} palabras más rápido de lo usual y con mayor precisión.`,
  stats_speech_compare_improved_wpm_one: "Leíste esta historia",
  stats_speech_compare_improved_wpm_two: "palabras más rápido de lo habitual. Tu precisión fue del",
  stats_speech_compare_improved_wpm_three: "por ciento.",
  stats_speech_compare_improved_accuracy_one: "Leíste esta historia con una precisión un",
  stats_speech_compare_improved_accuracy_two: "por ciento mayor que la habitual.",
  even_better: "Seguiremos trabajando para mejorar aún más.",
  work_to_get_better: "Podemos seguir mejorando.",
  times_up: "Se acabó el tiempo",
  finished_story: "Terminaste la historia",
  all_done: "Ya terminaste",
  speed: "Velocidad",
  average_speed: "Velocidad promedio",
  correct: "Correcto",
  average_correct: "Promedio de palabras correctas",
  great_work: "¡Buen trabajo!",

  //GENERAL DISPLAY
  example: "ejemplo",
  go_to_the: "Ir al", //TRANSLATE
  tracking_report: "Informe de seguimiento", //TRANSLATE
  recommendation_intervention: "Intervención", //TRANSLATE
  recommendation_catch_up: "Ponerse al día", //TRANSLATE
  recommendation_at_above: "En/Arriba", //TRANSLATE
  print_letters: "Imprimir Cartas", //TRANSLATE

  //ERROR MODALS
  audio_error_speech: "No logro entenderte, así que tendremos que empezar de nuevo. Comprueba que tu micrófono no esté silenciado y asegúrate de hablar alto y claro. Cuando quieras volver a intentarlo, haz clic en el botón 'Reiniciar'.",
  error_speech: "Lo siento, ha habido un error y tendremos que empezar de nuevo. Cuando quieras volver a intentarlo, haz clic en el botón 'Cerrar y reiniciar'.",
  mute_error_speech: "Parece que tu micrófono está silenciado. Reactiva el audio del micrófono y haz clic en 'Continuemos' para seguir adelante.",
  disabled_error_speech: "Parece que no has habilitado el acceso a tu micrófono. Habilita tu micrófono y haz clic en el botón para continuar.",
  kid_error_speech: "¡Oh, oh! ¡Necesitamos ayuda! Levanta la mano para que tu docente venga a ayudarnos.",
  error_text: " Lo siento, pero algo salió mal y tendré que reiniciar tu evaluación.",
  mute_error_text: "Parece que tu micrófono está silenciado. Comprueba que el audio esté activado y haz clic en el siguiente botón para comenzar.",
  audio_error_text: "No logro entenderte. Comprueba que tu micrófono no esté silenciado y asegúrate de hablar alto y claro.",
  compat_error_text: "Parece que tu navegador no es compatible o no está actualizado. Instala Chrome 70 o una versión posterior para poder leer.",
  compat_error_text_os: "Parece que tu sistema operativo no es compatible no está actualizado.",
  compat_error_no_spanish: "Tu navegador no es compatible con la práctica en español. Presiona 'Continuemos' para volver al menú principal.",
  compat_error_text_mobile: "Parece que tu dispositivo móvil no es compatible.",
  compat_error_text_ipad: "Parece que tu navegador no es compatible o no está actualizado. Instala iOS 12 o una versión posterior para poder leer.",
  disabled_error_continue: "Parece que no has habilitado el acceso a tu micrófono. Habilita tu micrófono en esta página web para continuar.",
  disabled_error_text: "Parece que no has habilitado el acceso a tu micrófono. Vuelve a iniciar sesión y selecciona 'Permitir' cuando se solicite el micrófono.",
  blank_error_text: "No logro escucharte bien. Presiona 'Cerrar sesión' para actualizar tu navegador. Tendrás que volver a iniciar sesión.",
  ipad_error_text: (brandedAppName) => `${brandedAppName} para Docentes aún no es compatible con dispositivos iPad. Para continuar como estudiante, haz clic en 'Aceptar' y vuelve a iniciar sesión con credenciales de estudiante.`,
  raise_your_hand: "Levanta la mano.",
  logout: "Cerrar sesión",
  im_ready: "Continuemos",
  restart: "Reiniciar",
  logout_and_restart: "Cerrar y reiniciar",
  browser_not_supported: "Tu navegador no es compatible",
  os_not_supported: "Tu sistema operativo no es compatible",
  mobile_not_supported: "Tu dispositivo móvil no es compatible",
  wait_modal_text: "Espera mientras guardo tu lectura",
  scoring_wait_modal_text: "Espera mientras guardo tu actividad puntuada",
  wait_modal_title: "Guardando",
  no_stories_for_you: "Has leído todas las historias que tenías disponibles. Levanta la mano y pídele ayuda a tu docente.",
  no_stories_for_you_text: "Ya se han leído todas las historias que forman parte de la prueba. Se puede continuar leyendo historias sin fines de evaluación.",
  all_stories_taken: "No hay historias disponibles",
  play_video_with_button: "Haz clic en el botón de reproducción para comenzar.",
  error_fetching_stories: "¡Vaya! No pude encontrar tus historias. Presiona el botón verde para intentarlo de nuevo.",
  error_fetching_stories_rec_code: "Error code 0001: Inténtelo de nuevo o por favor póngase en contacto con el equipo de apoyo.",
  error_fetching_stories_story_code: "Error code 0002: Inténtelo de nuevo o por favor póngase en contacto con el equipo de apoyo.",
  error_fetching_stories_put_activity_code: "Error code 0003: Inténtelo de nuevo o por favor póngase en contacto con el equipo de apoyo.",
  error_fetching_stories_title: "¡Vaya! No pude encontrar tus historias. ",
  try_again: "Inténtalo otra vez",
  paused_from_bad_network_speech: "Parece que hay un problema con la Internet. Intentaré a conectar de nuevo.",
  paused_from_bad_network_title: "¡uy!",
  resume_from_bad_network_ready: "¡Podemos comenzar!",
  resume_from_bad_network_speech: "¡Estamos de vuelta! Haz clic en el botón de inicio y comienza a leer.",
  resume_from_bad_network_continue: "Fuera",
  retry_pause_network_speech: "Aún no se resuelve el problema. Cuenta hasta tres, y inténtalo otra vez.",
  retry_pause_network_title: "¡Oh no!",
  retry_pause_network_button: "Inténtelo de nuevo",
  critical_network_speech: "Vamos a pedirle ayuda a tu docente. Por favor, levanta la mano.",

  //TUTOR
  read_with_me_mode: "Leamos en equipo una parte de esta historia. Yo leeré cada oración y, cuando termine, intentarás leerla tú.",
  end_read_with_me_mode: "Voy a leer una oración más. Luego, seguirás leyendo tú.",
  intervention_strings: ES_MX_INTERVENTION_STRINGS,
  student_checks: {
    intro: "¡Por fin estás aquí!",
    intro_triple_yes: "¡Sí, sí y sí!",
    intro_excited: "¡Qué emoción!",
    intro_continued: '¡Siento que llevo SIGLOS esperando para leer contigo!',
    intro_finished: (tutorName) => `¡Hola, soy ${tutorName}!`,
    intro_microphone: "¿Qué tal estás?<break time=\"1.5s\"/>",
    welcome_back: "¡Me alegra verte de nuevo!",
    wait_while_i_check: "Espera mientras compruebo algunas cosas.",
    microphone_access_granted: "¡Que comience la fiesta de la lectura!<break time=\"1s\"/>",
    intro_amira_moveon_one: "Bueno, en realidad no viniste solo para bailar. ¡Estás aquí para LEER!",
    intro_amira_moveon_two: "¡Soy TU asistente de lectura personal",
    intro_amira_moveon_three: "y te ayudaré a leer con confianza! ¿¡Y adivina qué!?",
    intro_screen: "Esta pantalla nos permitirá leer CUALQUIER historia que queramos, y yo te ayudaré en el camino.<break time=\".5s\"/>",
    intro_assessment_mode: "Comprobemos que puedo escucharte. ¡Así podremos comenzar!",
    volume_check_intro_one: "Conoceremos todo tipo de personajes extraordinarios.", // glance
    volume_check_intro_two: "Te doy mi palabra y ¡te lo demostraré! Este...",
    check_on_spot_intro: "¡es uno de mis personajes favoritos!", // mid range point at 3 o clock
    check_on_spot_intro_part_two: "¡Veamos qué hace mi amigo Spot!<break time=\"1s\"/>",
    oh_hes_sleeping: "¡Vaya! Está durmiendo.", // wide eyed animation
    lets_wake_him_up_one: "¡Vamos a despertarlo! Necesitamos hablar lo suficientemente alto como para que nos oiga,", //pointdown
    talk_loud_enough: "Necesitamos hablar lo suficientemente alto como para que nos oiga,",
    lets_wake_him_up_two: "pero no TAN alto como para asustarlo",
    lets_wake_him_up_three: "Cuando este micrófono se ponga verde",
    wake_up_spot: "tú dirás ¡Despierta, Spot!",
    he_heard_you: "¡Te oyó! Eso es exactamente lo que debes hacer al leer conmigo. ", // excited //waves
    he_heard_you_loud: "Bien, creo que Spot puede oírte.",
    he_heard_you_two: "Me alegró verte, Spot. ¡Hasta luego!",
    finish_asr_check: "¡Perfecto! ¡Esto será genial!", // thumbs up
    handle_too_soft_one: "Mmm... No te oyó. Cuando el micrófono esté verde, vuelve a decirlo más alto: \"¡Despierta, Spot!\" <break time=\"1.5s\"/>",
    handle_too_soft_second_round: "¡Vaya! Aun así no pudo oírte. <break time=\"1.5s\"/>",
    handle_too_soft_second_round_two: "¿Tienes el micrófono frente a tu boca? ¿Puedes comprobarlo?<break time=\"1.5s\"/>",
    handle_too_soft_second_round_three: "¿Estás hablando alto y claro?",
    handle_too_soft_second_round_four: "Intenta despertarlo otra vez.",
    handle_too_loud_one: "¡Cuidado! ¡No queremos asustarlo!<break time=\"1.5s\"/>",
    handle_too_loud_two: "¿El micrófono TOCA tu boca? ¿Puedes alejarlo un poco?<break time=\"1.5s\"/>",
    handle_too_loud_three: "Ahora, hablando un poco más suave, di: ¡Despierta, Spot! <break time=\"1.5s\"/>",
    handle_no_audio_one: "¡Vaya! ¡No pude oírte! Si estás usando auriculares, intenta presionar el botón del cable para reactivar el audio.<break time=\"2s\"/>",
    handle_no_audio_part_two: "cuando el micrófono esté verde, en voz alta y clara",
    handle_no_audio_two: "Todavía no te oigo. Intentemos algo diferente. Nos iremos y regresaremos. ¿Puedes cerrar y reiniciar la aplicación? ¡Nos vemos a la vuelta!<break time=\"1s\"/>",
    handle_get_teacher: "Vamos a pedirle ayuda a tu docente. Por favor, levanta la mano.",
    handle_get_teacher_two: "¿Puedes levantar la mano que tu docente nos ayude?",
    teacher_mode_volume_welcome_one: "Gracias por venir a ayudarnos. No oigo a tu estudiante cuando lee. ¿Podemos intentarlo contigo? Por favor, di: \"¡Despierta, Spot!\"",
    teacher_mode_volume_success_one: "¡Excelente! Puedo oírte. ¿Podrías asegurarte de que tu estudiante esté cerca del micrófono y hable en voz alta y clara?",
    teacher_mode_volume_student_retry: "Por favor, deja que tu estudiante lo intente de nuevo.",
    teacher_mode_volume_success_but_loud_one: "Todavía se oye muy alto. ¿Puedes hablar más bajo o ajustar el volumen del micrófono y pedirle a tu estudiante que lo intente de nuevo?",
    teacher_mode_volume_failure_one: "¡Oh, no! Apenas puedo oírte. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.",
    network_ping_error: "¡Por fin estás aquí! ¡Qué emoción! Mmm... parece que hay un problema con la Internet.",
    return_user_wake_up_prompt: "¿Puedes despertar a mi amigo Spot? <break time=\"1s\"/>",
    return_user_talk_loud_enough: "Necesitamos que hables lo suficientemente alto como para despertarlo.",
    student_hardware_denied: "Mmm... parece que hay un problema con el micrófono.",
    student_hardware_denied_two: "Vamos a pedirle ayuda a tu docente. Por favor, levanta la mano.<break time=\"1s\"/>",
    student_hardware_prompt_intro: "¡Oh! ¡Casi lo olvido! Tienes que encender tu MICRÓFONO para que yo pueda oírte.",
    student_hardware_prompt_initial: "¡Presiona 'Habilitar' y podremos comenzar!",
    student_hardware_prompt: "¡Tú puedes! ¡Presiona 'Habilitar' para que podamos comenzar!",
    student_hardware_prompt_two: "¿Sigues ahí? Presiona el botón Habilitar que aparece a la derecha.",
    student_hardware_manually_fixed: "¡Gracias! Ya solo tienes que cerrar y reiniciar. Nos vemos en un minuto.",
    prompt_ios_device_mic_modal_error: "No. Presiona el botón Habilitar que aparece a la derecha.",
    prompt_ios_device_mic_modal_success: "Presiónalo de nuevo, una vez más.",
    prompt_ios_device_mic_modal_got_it: "¡Muy bien!",
    student_asr_initial_prompt: "Ahora di: '¡Podemos comenzar!'.",
    student_asr_reminder_one: "No te oí. Por favor, di: 'Podemos comenzar'.",
    student_asr_reminder_two: "¿Puedes volver a intentarlo? Habla por el micrófono y di: \'Podemos comenzar'\"",
    student_asr_reminder_three: "Todavía no oigo nada. Por favor, di \'Podemos comenzar'\".",
    student_asr_get_teacher: "Vamos a pedirle ayuda a tu docente. Por favor, levanta la mano.",
    teacher_mode_asr_initial_prompt_one: "Gracias por venir a ayudarnos. No oigo a su estudiante cuando lee. ¿Podemos intentarlo con usted?",
    teacher_mode_asr_initial_prompt_two: "Por favor, diga: \'Podemos comenzar'\"",
    teacher_mode_asr_reminder_one: "No le oí. ¿Puede intentarlo de nuevo? Cuando el micrófono esté verde, diga \'Podemos comenzar'.\"",
    teacher_mode_asr_success: "¡Excelente! Parece que puedo oírle.",
    teacher_mode_asr_failure_flagging_prompt_one: "En este caso particular, ¿se le hace difícil entender a su estudiante?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "Comprendo. Haré algunos ajustes para este caso específico. Por favor, asegúrese de su estudiante esté en un lugar silencioso y de que tenga el micrófono cerca de la boca.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Bien, asegúrese de que su estudiante acerque la boca al micrófono y hable en voz alta y clara.",
    teacher_mode_asr_failure_high_bgn_one: "Oigo mucho ruido de fondo. Ayude a su estudiante a buscar un lugar más silencioso. Además, recuérdele que debe hablar por el micrófono en voz alta y clara.",
    teacher_mode_asr_failure_none_worked_one: "¡Oh, no! Apenas puedo oírle. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.",
  }
}


export let COPY_STRINGS = EN_US_COPY_STRINGS;

export function setCopyStrings(locale) {
  switch(locale){
    case("en-us"):
      COPY_STRINGS = EN_US_COPY_STRINGS;
      break;
    case("es-mx"):
      COPY_STRINGS = ES_MX_COPY_STRINGS;
      break;
    default:
      COPY_STRINGS = EN_US_COPY_STRINGS;
      break;
  }
}

function getInterface() {
  return isTouchDevice() ? "finger" : "mouse";
}

function getSpanishInterface() {
  return isTouchDevice() ? "dedo" : "ratón";
}

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function spell(letters) {
  let tts = "";
  for (const char of letters) tts += `${char}. `;
  return tts;
}